/* INTEGY V520 search runtime: legacy catalog helpers retained without legacy UI boot; V520 owns predictive and submitted search. */
/* INTEGY V520 catalog helper base. Legacy UI boot is disabled; the V520 module is the sole search owner. */
/* INTEGY V508 — canonical search runtime plus authoritative exact-numeric SKU handling. */
/* INTEGY V495 - search relevance + resilient image owner.
   V495 preserves V482 full-token relevance while making fast-search photography
   reliable: Shopify/native images are kept, visible catalog cards hydrate at once,
   six lookups may run concurrently, successful product JSON is cached, and the
   catalog image is retained as a fallback before the generic placeholder. */
!function(){"use strict";if(!window.IntegyV506Search){var e=window.INTEGY_V426_SEARCH||{},t=document.documentElement,r="integy-v426-search-panel",n=null,i=0,a=0,s=Object.create(null),c=null,o=Object.create(null),u=[],l=0;var d={close:Z,score:$,localSearch:j,runSearchPage:de,refineNumericResults:U,refineSkuResults:refineSkuResults,parsePredictive:z,dedupe:O,rankCollections:rankCollections,specialtyLevel:specialtyLevel};d.version="V520-helper-base",window.IntegyV495Search=d,window.IntegyV499Search=d,window.IntegyV500Search=d,window.IntegyV501Search=d,window.IntegyV504Search=d,window.IntegyV505Search=d,window.IntegyV506Search=d,window.IntegyV508Search=d,t.classList.add("integy-v501-search-owner","integy-v506-search-owner","integy-v508-search-owner"),window.IntegyV520LegacyApiReady=!0}function h(e,t){try{return(t||document).querySelector(e)}catch(e){return null}}function g(e,t){try{return Array.prototype.slice.call((t||document).querySelectorAll(e))}catch(e){return[]}}function f(e){return String(null==e?"":e).replace(/\s+/g," ").trim()}function p(e){return f(e).toUpperCase().replace(/[^A-Z0-9]/g,"")}function m(e){return p(e).replace(/\D/g,"")}function v(e){return String(e||"").toUpperCase().match(/\d+/g)||[]}function y(e){return String(null==e?"":e).replace(/[&<>"']/g,function(e){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[e]})}function b(e){var t=Object.create(null);return(e||[]).filter(function(e){return!(!(e=String(e||""))||t[e]||(t[e]=!0,0))})}function w(e){return String(e||"").toLowerCase().replace(/(\d+)\s*[\.,]\s*0(?:(?:\s*)(?:m\s*m|mm))?/g,"$1mm").replace(/(\d+)\s*(?:m\s*m|mm)\b/g,"$1mm").replace(/&/g," and ").replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim()}function S(e){return w(e).split(" ").filter(function(e){return e.length>1})}function _(e,t){var r=w(e);return!!(t=w(t))&&(/^\d+$/.test(t)?v(r).some(function(e){return e===t}):(" "+r+" ").indexOf(" "+t+" ")>=0)}function x(e){var t=f(e).replace(/^Type:\s*/i,"");if(!t)return"";if(/\bwashers?\b/i.test(t))return"Washer";if(/\be[- ]?clips?\b/i.test(t))return"E-Clip";if(/\bwheel\s+nuts?\b/i.test(t))return"Wheel Nut";if(/\block\s+nuts?\b/i.test(t))return"Lock Nut";if(/hex\s+nut\s+wrench/i.test(t))return"Hex Nut Wrench";if(/turnbuckle\s+wrench/i.test(t))return"Turnbuckle Wrench";if(/48\s*[- ]?pitch\s+pinion/i.test(t))return"48-Pitch Pinion Gear";if(/steering\s+tie\s+rod/i.test(t))return"Steering Tie Rod";if(/motor\s+(?:alignment|centering)\s+(?:tool|gauge)/i.test(t))return"Motor Alignment Tool";if(/(?:replacement\s+)?wrench\s+tip|tip\s+for\s+(?:hex\s+)?wrench/i.test(t))return"Wrench Tip";if(/cross\s+wrench/i.test(t))return"Cross Wrench";if(/wheel\s+nut\s+wrench/i.test(t))return"Wheel Nut Wrench";if(/flywheel\s+wrench/i.test(t))return"Flywheel Wrench";if(/glow\s+plug\s+wrench/i.test(t))return"Glow Plug Wrench";if(/suspension\s+(?:link|linkage)|linkage\s+(?:set|rod)/i.test(t))return"Suspension Linkage";if(/universal\s+drive\s+shaft|\bdrive\s+shaft/i.test(t))return"Drive Shaft";if(/\bpinion\s+gear/i.test(t))return"Pinion Gear";if(/\bspur\s+gear/i.test(t))return"Spur Gear";if(/gearbox\s+housing/i.test(t))return"Gearbox Housing";if(/performance\s+shock\s+set|\bshock\s+set/i.test(t))return"Shock Set";if(/servo\s+horn/i.test(t))return"Servo Horn";if(/^tie\s+rod\b/i.test(t))return"Tie Rod";if(/radio\s+system/i.test(t)&&/receiver/i.test(t)&&/gyro/i.test(t))return"Radio System / Receiver / Gyro";if(/radio\s+system/i.test(t)&&/receiver/i.test(t))return"Radio System / Receiver";if(/crawler\s+axles?/i.test(t))return"Crawler Axle Set";if(/radio\s+system/i.test(t))return"Radio System";if(/receiver\s+box/i.test(t))return"Receiver Box";if(/\breceiver\b/i.test(t)&&/radio\s+controllers?|tx\s+receivers?/i.test(t))return"Receiver";var r=(t=t.split(/\s+1\/\d+|\s+for\s+|\s*\|\s*/i)[0]).split(/\s+/),n=[];return r.forEach(function(e){n.length&&n[n.length-1].toLowerCase()===e.toLowerCase()||n.push(e)}),f(n.join(" ")).slice(0,52)}function intentStem(e){var t=String(e||"").toLowerCase(),m={arms:"arm",braces:"brace",bumpers:"bumper",bulkheads:"bulkhead",mounts:"mount",wheels:"wheel",tires:"tire",tyres:"tire",shocks:"shock",towers:"tower",axles:"axle",shafts:"shaft",gears:"gear",pinions:"pinion",spurs:"spur",servos:"servo",horns:"horn",savers:"saver",wrenches:"wrench",tips:"tip",drivers:"driver",bearings:"bearing",bodies:"body",lights:"light",springs:"spring",links:"link",rods:"rod",skids:"skid",plates:"plate",trays:"tray",hubs:"hub",knuckles:"knuckle",carriers:"carrier",differentials:"differential",gearboxes:"gearbox",transmissions:"transmission",batteries:"battery",connectors:"connector",plugs:"plug",receivers:"receiver",radios:"radio",controllers:"controller",screws:"screw",nuts:"nut",adapters:"adapter",stations:"station",heatsinks:"heatsink",covers:"cover",cages:"cage",racks:"rack",turnbuckles:"turnbuckle"};return m[t]||t}function partIntentToken(e){return /^(?:chassis|brace|bumper|bulkhead|mount|wheel|tire|shock|tower|arm|axle|shaft|gear|pinion|spur|servo|horn|saver|wrench|tip|driver|bearing|body|light|led|spring|link|rod|skid|plate|tray|hub|knuckle|carrier|differential|gearbox|transmission|battery|connector|plug|esc|receiver|radio|controller|screw|nut|adapter|station|heatsink|cover|cage|rack|diff|turnbuckle)$/.test(intentStem(e))}function primaryTitle(e){return f(e&&e.title||"").split(/\s*\|\s*/)[0]}function intentHas(e,t){return _(e,t)||_(e,t+"s")||("body"===t&&_(e,"bodies"))||("battery"===t&&_(e,"batteries"))}function intentMismatch(e,t){var r=S(t),q=w(t),primary=w(primaryTitle(e)),type=w(x(e&&e.type||"")),full=w((e&&e.title||"")+" "+(e&&e.type||"")+" "+(e&&e.tags||""));if(q.indexOf("m chassis")>=0&&!/\bm chassis\b/.test(full))return 1;if(q.indexOf("x monster chassis")>=0&&!/\bx monster chassis\b/.test(full))return 1;var i=(primary+" "+type).replace(/\bsetup boards? chassis setup tools?\b/g,"setup station").replace(/\bm chassis\b/g,"").replace(/\bx monster chassis\b/g,"");var phrases=[["suspension arm",/\bsuspension arms?\b/],["chassis brace",/\bchassis braces?\b/],["motor mount",/\bmotor mounts?\b/],["body mount",/\bbody mounts?\b/],["servo horn",/\bservo horns?\b/],["pinion gear",/\bpinion gears?\b/],["spur gear",/\bspur gears?\b/],["battery tray",/\bbattery trays?\b/],["setup station",/\bsetup stations?\b/],["shock tower",/\bshock towers?\b/]];for(var z=0;z<phrases.length;z+=1)if(q.indexOf(phrases[z][0])>=0&&!phrases[z][1].test(i))return 1;if(/(?:wrench tip|tip wrench)/.test(q)&&!(intentHas(i,"tip")&&(intentHas(i,"wrench")||intentHas(i,"driver")||intentHas(i,"hex"))))return 1;var n=r.map(intentStem).filter(partIntentToken);/(?:setup station|m chassis|x monster chassis)/.test(q)&&(n=n.filter(function(e){return"chassis"!==e}));if(!n.length)return 0;return n.filter(function(e){return!intentHas(i,e)}).length}function k(e){var t=f(e).toLowerCase();try{t=decodeURIComponent(t)}catch(e){}return t.replace(/[^a-z0-9-]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,"")}function E(e){try{var t=new URL(String(e||""),location.origin).pathname.match(/^\/products\/([^/?#]+)/i);return t?k(decodeURIComponent(t[1])):""}catch(e){return""}}function L(e){try{var t=new URL(String(e||""),location.origin).pathname.match(/^\/products\/([^/?#]+)/i),r=t?k(decodeURIComponent(t[1])):"";return r?"/products/"+r:""}catch(e){return""}}function catalogRecordValid(e){if(!e||"catalog"!==e._source)return!0;var t=p(e.sku),r=p(E(e.url));return!!t&&!!r&&r.indexOf(t)>=0}function A(e){try{var t=new URL(String(e||""),location.origin).pathname.match(/^\/collections\/([^/?#]+)/i);return t?"/collections/"+k(t[1]):""}catch(e){return""}}function C(e){if(!(e=String(e||"").trim()))return"";if(/^\/cdn\/shop\//i.test(e))return e;/^\/\//.test(e)&&(e=location.protocol+e);try{var t=new URL(e,location.origin);if(t.origin===location.origin||/(?:^|\.)shopifycdn\.com$/i.test(t.hostname)||/(?:^|\.)cdn\.shopify\.com$/i.test(t.hostname)||/(?:^|\.)integy\.com$/i.test(t.hostname))return t.href}catch(e){}return""}function M(e){if(!(e=C(e)))return 0;try{var t=new URL(e,location.origin);if(/^\/cdn\/shop\//i.test(t.pathname)||t.origin===location.origin||/(?:^|\.)shopifycdn\.com$/i.test(t.hostname)||/(?:^|\.)cdn\.shopify\.com$/i.test(t.hostname))return 4;if(/ssl-firewall/i.test(t.hostname))return 1;if(/(?:^|\.)integy\.com$/i.test(t.hostname))return 2}catch(e){}return 1}
function specialtyQuery(e){return /(?:prototype|used|open[ -]?box|scratch(?:\s*&\s*|\s+and\s+|[- ])?dent|one[ -]?of[ -]?a[ -]?kind|take[ -]?off|replacement|new[, -]+scratch|like[ -]?new)/i.test(String(e||""))}
function specialtyLevel(e){var t=[e&&e.title,e&&e.type,e&&e.tags,e&&e.description,e&&e.url,E(e&&e.url)].join(" ").toLowerCase();return /(?:used-open-box-scratch-dent|one-of-a-kind-open-box-scratch-dent|one[ -]?of[ -]?a[ -]?kind|open[ -]?box|scratch(?:\s*&\s*|\s+and\s+|[- ])?dent|new[, -]+scratch|like[ -]?new|take[ -]?off|prototype|\bused\b)/i.test(t)?3:/(?:replacement parts?|\breplacement\b)/i.test(t)?2:0}
function exactSkuQuery(e,t){var r=f(t).toUpperCase();return b([e&&e.sku].concat(e&&e.variantSkus||[])).some(function(e){return f(e).toUpperCase()===r})}
function collectionRank(e,t){var r=w(t),n=S(t),i=w(e&&e.title),a=0;return i===r&&(a+=300),0===i.indexOf(r)&&(a+=180),i.indexOf(r)>=0&&(a+=100),n.length&&n.every(function(e){return _(i,e)})&&(a+=100),/^shock$/.test(r)&&(/shocks?\s*(?:and|&)\s*suspension|rc\s+shocks?\s*(?:and|&)?\s*suspension/i.test(e.title||"")&&(a+=240),/^shock/i.test(e.title||"")&&(a+=120),/(?:tool|plier|scissor|oil|fluid)/i.test(e.title||"")&&(a-=260)),a}
function collectionIntentKey(e){return w(e).replace(/\b(?:for\s+rc|rc\s+cars?|boats?|planes?|helicopters?)\b/g," ").replace(/\btapping\b/g,"tap").replace(/\bwrenches\b/g,"wrench").replace(/\btools?\b/g," ").replace(/\s+/g," ").trim()}function rankCollections(e,t){var r=Object.create(null),n=[];(e||[]).forEach(function(e){var i=A(e&&e.url);i&&!r[i]&&(r[i]=!0,n.push({url:i,title:f(e.title),_score:collectionRank(e,t)}))}),n.sort(function(e,t){return(t._score||0)-(e._score||0)||String(e.title||"").localeCompare(String(t.title||""))});var i=Object.create(null),a=[];return n.forEach(function(e){var t=collectionIntentKey(e.title)||e.url;i[t]||(i[t]=!0,a.push(e))}),a}
function T(e){if(!/(?:wrench|allen|hex|tip|driver|tool|bit)/i.test(e||""))return null;var t=String(e||"").match(/(^|[^0-9])(\d{1,2})(?:[\.,](\d))?\s*(?:m\s*m|mm)?(?=$|[^0-9])/i);if(!t)return null;var r=Number(t[2]+(t[3]?"."+t[3]:""));return isFinite(r)&&r>0&&r<=10?r:null}function $(e,t){
var r=f(t),n=p(r),i=m(r),a=!/\s/.test(r)&&/^(?:[A-Z]{1,5}[\-./_]*)?\d{2,}[A-Z0-9\-./_]*$/i.test(r),hasAlpha=/[A-Z]/i.test(r),s=w(r),c=S(r),o=T(r);
null!=o&&(c=c.filter(function(e){return!/^\d+(?:\.\d+)?mm$/.test(e)}));
var u=w(e.title),l=w(E(e.url)),d=w((e.type||"")+" "+(e.tags||"")),h=w(e.description||""),g=b([e.sku].concat(e.variantSkus||[])).filter(Boolean),y=0;
g.forEach(function(e){var t=p(e),skuNums=v(e),exact=f(e).toUpperCase()===r.toUpperCase();
exact&&(y=Math.max(y,1e5));
t===n&&(y=Math.max(y,94e3));
if(!hasAlpha&&a&&i){
  skuNums.some(function(e){return e===i})&&(y=Math.max(y,91e3));
  skuNums.some(function(e){return 0===e.indexOf(i)})&&(y=Math.max(y,70e3));
  skuNums.some(function(e){return e.indexOf(i)>0})&&(y=Math.max(y,18e3));
}
if(n&&0===t.indexOf(n))y=Math.max(y,hasAlpha?88e3:80e3);
if(n&&t.indexOf(n)>0)y=Math.max(y,hasAlpha?34e3:18e3);
});
if(s){u===s&&(y=Math.max(y,79e3));0===u.indexOf(s)&&(y=Math.max(y,61e3));if(/^\d+$/.test(s)){var titleNums=v(e.title);titleNums.some(function(e){return e===s})&&(y=Math.max(y,55e3));titleNums.some(function(e){return 0===e.indexOf(s)&&e!==s})&&(y=Math.max(y,50e3))}else u.indexOf(s)>=0&&(y=Math.max(y,55e3))}
c.length&&c.every(function(e){return _(u,e)})&&(y=Math.max(y,53e3));
c.length&&c.every(function(e){return _(u+" "+l,e)})&&(y=Math.max(y,44e3));
c.length&&c.every(function(e){return _(d,e)})&&(y=Math.max(y,33e3));
c.length&&c.every(function(e){return _(h,e)})&&(y=Math.max(y,12e3));
if(null!=o){var x=function(e){var t=[];return String(e||"").replace(/(\d{1,2}(?:\.\d)?)\s*(?:m\s*m|mm)\b/gi,function(e,r){return t.push(Number(r)),e}),t.filter(function(e){return isFinite(e)&&e<=10})}(e.title);x.some(function(e){return Math.abs(e-o)<.04})?y+=8e3:x.length&&(y-=3e4),/(?:wrench|allen|hex|tip|driver|tool|bit)/i.test(e.title||"")||(y-=12e3)}
var genuineRelevance=y>0;
var k=specialtyLevel(e),L=specialtyQuery(r),A=exactSkuQuery(e,r),replacementIntent=/(?:tip|wrench|hex|driver|replacement|shaft|bit|tool)/i.test(r);e._specialty=k;e._titleMatch=u===s?3:0===u.indexOf(s)?2:u.indexOf(s)>=0?1:0;e._titleLength=String(e.title||"").length;e._skuPrefixQuery=a&&hasAlpha?1:0;
/* V495/V482: the 3-character JSON indexes only choose candidates. A candidate must have
   real full-query relevance before specialty or availability can influence ranking. */
if(!genuineRelevance)return 0;
if(k&&!L&&!A){
 if(3===k)y-=7e4;
 else if(2===k&&!replacementIntent)y-=3e4;
 else if(2===k&&replacementIntent)y+=6e3;
 y=Math.max(1,y);
}
var mismatch=!a&&intentMismatch(e,r);e._intentMismatch=mismatch;if(mismatch)return 0;else if(c.length>1&&c.some(partIntentToken))y+=12e3;
/* Stock is a tie-break/quality boost only after relevance is established. */
!1===e.available?y-=4500:y+=1800;return Math.max(0,y)}
function R(e){if(!e)return Promise.resolve(null);if(s[e])return s[e];var t=window.AbortController?new AbortController:null,r=setTimeout(function(){t&&t.abort()},4800);return s[e]=fetch(e,{credentials:"same-origin",cache:"force-cache",signal:t&&t.signal}).then(function(e){if(!e.ok)throw new Error("Not found");return e.json()}).catch(function(){return null}).then(function(e){return clearTimeout(r),e}),s[e]}function P(){return e.indexBase||window.INTEGY_FILTER_INDEX_ASSET_BASE||"/cdn/shop/t/0/assets/"}function I(e,t){if(!(t=String(t||"").toLowerCase()))return"";var r=P()+"integy-v456-search-"+e+"-"+encodeURIComponent(t)+".json",n=window.INTEGY_SEARCH_SCHEMA_VERSION||"V505-CENTS-2";return r+(r.indexOf("?")>=0?"&":"?")+"v="+encodeURIComponent(n)}function searchFamily(e){var t=p(e&&e.sku||"").replace(/(?:BLACK|BLUE|GREEN|GREY|GRAY|GUN|GOLD|ORANGE|PINK|PURPLE|RED|SILVER|TITANIUM|CHROME)$/i,"");if(t)return t;return w(e&&e.title||"").replace(/\b(?:black|blue|green|grey|gray|gunmetal|gold|orange|pink|purple|red|silver|titanium|chrome)\b/g,"").replace(/\s+/g," ").trim()}
function skuMatchTier(e,t){var r=p(t),n=[];if(!r)return 0;n.push(r),/^C\d{3,}[A-Z0-9]*$/.test(r)&&n.push(r.slice(1));var i=0;return b([e&&e.sku].concat(e&&e.variantSkus||[])).map(p).forEach(function(e){n.forEach(function(t){e===t?i=Math.max(i,4):0===e.indexOf(t)?i=Math.max(i,3):0===t.indexOf(e)?i=Math.max(i,2):t.length>=5&&e.indexOf(t)>0&&(i=Math.max(i,1))})}),i}
function O(e,t){var r=Object.create(null),query=t;(e||[]).forEach(function(e){var n,i=(n=e)?Array.isArray(n)?{sku:n[0]||"",title:n[1]||"",url:L(n[2]||""),image:C(n[6]||""),price:function(e){if(""===e||null==e)return"";var t=Number(e);return isFinite(t)?"$"+(t/100).toFixed(2):""}(n[3]),price_cents:Number(n[3]),type:n[4]||"",tags:n[7]||"",description:n[8]||"",variantSkus:n[5]||[],available:9>=n.length?!0:!!n[9],_source:"catalog"}:n:null;if(i&&L(i.url)&&catalogRecordValid(i)&&(i.url=L(i.url),i.image=C(i.image),i._source||(i._source="native"),i._skuMatch=skuMatchTier(i,query),i.score=$(i,query),i.score)){var a=function(e){return p(e&&e.sku)||p(e&&e.variantSkus&&e.variantSkus[0])||L(e&&e.url)||p(e&&e.title)}(i);r[a]=function(e,t){if(!e)return t;if(!t)return e;var eNative="catalog"!==e._source,tNative="catalog"!==t._source,r=tNative&&!eNative?t:eNative&&!tNative?e:(t.score||0)>(e.score||0)?t:e,n=r===t?e:t;return r.score=Math.max(e.score||0,t.score||0),r._skuMatch=Math.max(e._skuMatch||0,t._skuMatch||0),M(n.image)>M(r.image)&&(r.image=n.image),["sku","title","price","price_cents","type","tags","description","url"].forEach(function(e){!f(r[e])&&f(n[e])&&(r[e]=n[e])}),"boolean"!=typeof r.available&&"boolean"==typeof n.available&&(r.available=n.available),r.variantSkus=b((r.variantSkus||[]).concat(n.variantSkus||[])),r}(r[a],i)}});var list=Object.keys(r).map(function(e){return r[e]}).sort(function(e,t){var r=(t._skuMatch||0)-(e._skuMatch||0);return r||((e._skuMatch||0)>0&&(t._skuMatch||0)>0?String(e.sku||"").localeCompare(String(t.sku||""),void 0,{numeric:!0,sensitivity:"base"}):0)||(t.score||0)-(e.score||0)||(!1===e.available?1:0)-(!1===t.available?1:0)||(e._specialty||0)-(t._specialty||0)||(t._titleMatch||0)-(e._titleMatch||0)||(e._titleLength||0)-(t._titleLength||0)||String(e.title||"").localeCompare(String(t.title||""))||String(e.sku||"").localeCompare(String(t.sku||""))});var seen=Object.create(null),primary=[],variants=[];list.forEach(function(e){var key=searchFamily(e);if(key&&seen[key])variants.push(e);else{key&&(seen[key]=!0);primary.push(e)}});return primary.concat(variants)}
function U(e,t){var r=f(t);if(!/^\d{3,6}$/.test(r))return e;var n=(e||[]).filter(function(e){return b([e.sku].concat(e.variantSkus||[])).some(function(e){return v(e).some(function(e){return e===r||0===e.indexOf(r)})})||v(e.title).some(function(e){return e===r||0===e.indexOf(r)})});return n.length?n:e}function skuQueryAliases(e){var t=p(e),r=[];if(t.length<4||!/[A-Z]/.test(t)||!/\d/.test(t))return r;r.push(t);/^C\d{3,}[A-Z0-9]*$/.test(t)&&r.push(t.slice(1));return b(r)}function refineSkuResults(e,t){var r=skuQueryAliases(t);if(!r.length)return e;var n=[],i=[],a=[];(e||[]).forEach(function(e){var t=0;b([e&&e.sku].concat(e&&e.variantSkus||[])).map(p).forEach(function(e){r.forEach(function(r){e===r?t=Math.max(t,3):0===e.indexOf(r)?t=Math.max(t,2):r.length>=5&&e.indexOf(r)>0&&(t=Math.max(t,1))})}),3===t?n.push(e):2===t?i.push(e):1===t&&a.push(e)});var s=n.concat(i,a);return s.length?s:e}function j(e){var t=function(e){var t=f(e),r=p(t).toLowerCase(),n=m(t).toLowerCase(),i=[],a=T(t),s=!/\s/.test(t)&&(/^(?:[a-z]{1,6}[\-./_]*)?\d{2,}[a-z0-9\-./_]*$/i.test(t)||/^3rac[\-./_]*[a-z0-9\-./_]*\d{2,}[a-z0-9\-./_]*$/i.test(t)),model=t.toLowerCase().match(/\bmodel\s+([3ysx])\b/);if(/^\d{2,}$/.test(t))i.push(I("number",n.slice(0,Math.min(3,n.length))));else if(s&&r.length>=2){i.push(I("sku",r.slice(0,3))),n.length>=3&&i.push(I("number",n.slice(0,Math.min(3,n.length))))}else{b(S(t).filter(function(e){return e.length>=2&&!/^(?:the|for|with|and|from|into|all|set|kit|part|parts|integy|machined|billet|upgrade|upgrades|rc|of|to|or|by|on)$/.test(e)&&!/^\d/.test(e)}).map(function(e){return e.slice(0,Math.min(3,e.length))})).slice(0,3).forEach(function(e){i.push(I("token",e))}),model&&i.unshift(I("token","model-"+model[1]))}return null!=a&&i.push(I("size",String(Math.round(10*a)))),!i.length&&r.length>=2&&i.push(I("sku",r.slice(0,3))),b(i.filter(Boolean)).slice(0,5)}(e);return Promise.all(t.map(R)).then(function(t){var r=t.map(function(e){var t=Object.create(null);return(e&&e.ids||[]).forEach(function(e){e=Number(e),isFinite(e)&&e>=0&&(t[e]=!0)}),t}).filter(function(e){return Object.keys(e).length}),n=[];if(r.length){var i=Object.keys(r[0]).filter(function(e){return r.every(function(t){return t[e]})});if(i.length)n=i.map(Number);else{var a=Object.create(null);r.forEach(function(e){Object.keys(e).forEach(function(e){a[e]=!0})}),n=Object.keys(a).map(Number)}}if(!n.length)return[];n.sort(function(e,t){return e-t});var s=Object.create(null);n.forEach(function(e){var t=Math.floor(e/256);(s[t]||(s[t]=[])).push(e)});var c=Object.keys(s).map(Number),o=function(t){var r=[];n.forEach(function(e){t[e]&&r.push(t[e])});return refineSkuResults(U(O(r,e),e),e)};if(c.length>40||n.length>2400)return R(P()+"integy-v456-search-catalog-full.json?v="+encodeURIComponent(window.INTEGY_SEARCH_SCHEMA_VERSION||"V505-CENTS-2")).then(function(e){var t=Object.create(null);return(e&&e.items||[]).forEach(function(e,r){t[r]=e}),o(t)});return Promise.all(c.map(function(e){return R(P()+"integy-v456-search-catalog-"+("000"+e).slice(-3)+".json?v="+encodeURIComponent(window.INTEGY_SEARCH_SCHEMA_VERSION||"V505-CENTS-2"))})).then(function(e){var t=Object.create(null);return e.forEach(function(e){if(e&&Array.isArray(e.items)){var r=Number(e.offset)||0;e.items.forEach(function(e,n){t[r+n]=e})}}),o(t)})})}function B(e){return(e=f(e)).length>=3&&!function(e){return e=f(e),!!/^\d{2,8}$/.test(e)||!/\s/.test(e)&&/^(?:[a-z]{1,7}[\-./_]*)?\d{2,}[a-z0-9\-./_]*$/i.test(e)}(e)}function N(e){var t="",r=-1;return String(e||"").split(",").forEach(function(e){var n=f(e).split(/\s+/),i=n[0]||"",a=parseInt(n[1],10)||0;i&&a>=r&&(t=i,r=a)}),t}function V(e){var t=e.getAttribute("data-integy-v430-image");if(C(t))return C(t);var r=h("img",e);if(!r)return"";for(var n=[r.currentSrc,r.getAttribute("src"),r.getAttribute("data-src"),r.getAttribute("data-rimg"),N(r.getAttribute("srcset")),N(r.getAttribute("data-srcset"))],i=0;i<n.length;i+=1)if(C(n[i]))return C(n[i]);return""}function z(e){var t={products:[],collections:[]};if(!e||!window.DOMParser)return t;var r=(new DOMParser).parseFromString(e,"text/html");return g('a[href*="/products/"]',r).forEach(function(e){var r=L(e.getAttribute("href"));r&&t.products.push({url:r,title:f((h(".search-flydown--product-title,[data-product-title]",e)||e).textContent),sku:f(e.getAttribute("data-integy-v430-sku")||(h(".integy-product-card-sku,[data-sku]",e)||{}).textContent).replace(/^SKU:\s*/i,""),image:V(e),price:f(e.getAttribute("data-integy-v430-price")||""),type:f(e.getAttribute("data-integy-v430-type")||""),tags:"",description:"",variantSkus:[]})}),g('a[data-integy-v433-collection],.search-flydown__queries-collections a[href*="/collections/"]',r).forEach(function(e){var r=A(e.getAttribute("href"));r&&t.collections.push({url:r,title:f(e.getAttribute("data-integy-v433-title")||e.textContent)})}),t}function H(e){if(c)try{c.abort()}catch(e){}var t=c=window.AbortController?new AbortController:null,r=setTimeout(function(){t&&t.abort()},3e3);return fetch(function(e){var t=window.Theme&&Theme.routes&&Theme.routes.predictive_search_url||"/search/suggest",r=new URLSearchParams;return r.set("q",e),r.set("section_id","predictive-search"),r.set("resources[type]",B(e)?"product,collection":"product"),r.set("resources[limit]","8"),r.set("resources[limit_scope]","each"),r.set("resources[options][unavailable_products]","show"),r.set("resources[options][fields]","title,product_type,variants.sku,tag"),t+"?"+r.toString()}(e),{credentials:"same-origin",signal:t&&t.signal}).then(function(e){if(!e.ok)throw new Error("Unavailable");return e.text()}).then(z).catch(function(){return{products:[],collections:[]}}).then(function(e){return clearTimeout(r),e})}function F(e,t,r){var n=h('input[name="'+t.replace(/"/g,'\\"')+'"]',e);n||((n=document.createElement("input")).type="hidden",n.name=t,e.appendChild(n)),n.value=r}function q(e){return!!(e&&e.matches&&e.matches('input[type="search"],input[name="q"]')&&e.closest('form[action*="/search"],form[role="search"]'))}function D(e){e&&"true"!==e.dataset.integyV431SearchReady&&(e.dataset.integyV431SearchReady="true",F(e,"type","product"),F(e,"options[prefix]","last"),F(e,"options[unavailable_products]","show"),F(e,"integy_fast","1"))}function G(e){var t=new URLSearchParams;return t.set("type","product"),t.set("q",f(e)),t.set("integy_fast","1"),t.set("options[prefix]","last"),t.set("options[unavailable_products]","show"),(window.Theme&&Theme.routes&&Theme.routes.search_url||"/search")+"?"+t.toString()}function K(){var e=document.getElementById(r);return e||((e=document.createElement("div")).id=r,e.className="integy-v426-search-panel integy-v431-search-panel",e.setAttribute("role","listbox"),e.setAttribute("aria-label","Product search suggestions"),e.hidden=!0,document.body.appendChild(e),e)}function W(e){var t=K(),r=(e.closest("form")||e).getBoundingClientRect(),n=e.getBoundingClientRect(),i=document.documentElement.clientWidth||window.innerWidth,a=i<740?10:12,s=i<740?i-2*a:Math.min(Math.max(r.width,520),780,i-2*a),c=i<740?a:Math.max(a,Math.min(r.left,i-a-s));t.style.setProperty("--integy-v426-panel-left",Math.round(c)+"px"),t.style.setProperty("--integy-v426-panel-top",Math.round(n.bottom+6)+"px"),t.style.setProperty("--integy-v426-panel-width",Math.round(s)+"px")}function Z(){if(n=null,i+=1,c)try{c.abort()}catch(e){}var e=document.getElementById(r);e&&(e.hidden=!0,e.innerHTML=""),t.classList.remove("integy-v426-search-open","integy-v431-search-open")}function Q(e){if(""===e||null==e)return"";var t=String(e).trim().replace(/,/g,""),r=Number(t.replace(/^\$/,""));return isFinite(r)?(/^\$/.test(t)||"string"==typeof e&&/\.\d+$/.test(t)?"$"+r.toFixed(2):"$"+(r/100).toFixed(2)):/^\$/.test(t)?t:"$"+t}function Y(t,r,n){var i=C(t&&t.image||""),a=M(i),s=a>=2?i:e.placeholder||"";return'<span class="'+n+'"><img src="'+y(s||e.placeholder||"")+'" data-integy-v431-image-fallback="true" data-integy-v495-catalog-image="'+y(i||"")+'" data-integy-v431-product-url="'+y(t.url||"")+'" alt="" width="480" height="480" loading="'+(r<8?"eager":"lazy")+'" decoding="async"'+(0===r?' fetchpriority="high"':"")+'></span>'}function X(t){g("img[data-integy-v431-image-fallback]",t||document).forEach(function(t){"true"!==t.dataset.integyV495FallbackBound&&(t.dataset.integyV495FallbackBound="true",t.addEventListener("error",function(){var r=C(t.getAttribute("data-integy-v495-catalog-image")||""),n=e.placeholder||"",i=t.getAttribute("src")||"";r&&i!==r&&"catalog"!==t.dataset.integyV495FallbackStage?(t.dataset.integyV495FallbackStage="catalog",t.setAttribute("src",r)):n&&i!==n&&(t.dataset.integyV495FallbackStage="placeholder",t.setAttribute("src",n))}))})}function J(e){if(!(e=L(e)))return Promise.resolve(null);if(o[e])return o[e];var t=window.AbortController?new AbortController:null,r=window.setTimeout(function(){t&&t.abort()},3800);return o[e]=fetch(e+".js",{credentials:"same-origin",cache:"force-cache",signal:t&&t.signal}).then(function(e){if(!e.ok)throw new Error("Unavailable");return e.json()}).catch(function(){return null}).then(function(e){return window.clearTimeout(r),e}),o[e]}function ee(e){if(!e)return"";var t=[e.featured_image,e.featured_media&&e.featured_media.preview_image&&e.featured_media.preview_image.src];e.images&&e.images.length&&t.push("string"==typeof e.images[0]?e.images[0]:e.images[0]&&e.images[0].src);for(var r=0;r<t.length;r+=1){var n=C(t[r]);if(M(n)>=3)return n}return""}function te(){for(;l<6&&u.length;)(function(t){l+=1,J(t.path).then(function(r){var n=ee(r),i=t.img&&C(t.img.getAttribute("data-integy-v495-catalog-image")||"");t.img&&t.img.isConnected&&(n?(t.img.dataset.integyV495FallbackStage="shopify",t.img.setAttribute("src",n)):i&&t.img.getAttribute("src")!==i&&(t.img.dataset.integyV495FallbackStage="catalog",t.img.setAttribute("src",i)))}).finally(function(){l-=1,te()})})(u.shift())}function re(e){if(e&&"true"!==e.dataset.integyV431HydrationQueued){var t=L(e.getAttribute("data-integy-v431-product-url"));t&&(e.dataset.integyV431HydrationQueued="true",u.push({img:e,path:t}),te())}}function ne(t){var r=g("img[data-integy-v431-product-url]",t||document).filter(function(t){var r=t.getAttribute("src")||"";return!r||r===(e.placeholder||"")||/integy-v4(?:30|31)-product-placeholder/i.test(r)});if(!r.length)return;r.slice(0,12).forEach(re);if(r.length>12&&window.IntersectionObserver){var n=new IntersectionObserver(function(e){e.forEach(function(e){e.isIntersecting&&(n.unobserve(e.target),re(e.target))})},{rootMargin:"900px 0px"});r.slice(12).forEach(function(e){n.observe(e)})}else r.slice(12,24).forEach(re)}function ie(e,t){return'<a class="integy-v426-search-suggestion" href="'+y(e.url)+'" role="option">'+Y(e,t,"integy-v426-search-suggestion__media")+'<span class="integy-v426-search-suggestion__copy"><strong>'+y(e.title)+"</strong>"+(e.sku?"<span>SKU: "+y(e.sku)+"</span>":"")+(storefrontType(e)?"<span>"+y(storefrontType(e))+"</span>":"")+(""!==e.price?"<span>"+y(Q(e.price))+"</span>":"")+(!0===e.available?'<span class="integy-v456-search-stock is-in-stock">In stock</span>':!1===e.available?'<span class="integy-v456-search-stock is-sold-out">Sold out</span>':"")+"</span></a>"}function ae(e){return'<a class="integy-v433-search-collection" href="'+y(e.url)+'"><span class="integy-v433-search-collection__icon" aria-hidden="true">⌕</span><span><strong>'+y(e.title)+'</strong><small>Browse compatible products</small></span><span aria-hidden="true">›</span></a>'}function se(e,t,r,a,s){if(s===i&&n===e&&f(e.value)===t){r=refineSkuResults(U(O(r,t),t),t).slice(0,B(t)?6:8),a=B(t)?rankCollections(a,t).slice(0,window.matchMedia&&window.matchMedia("(pointer: coarse), (max-width: 740px)").matches?2:3):[];var c=K(),o="";a.length&&(o+='<section class="integy-v433-search-collections" aria-label="Shop by vehicle or category"><h3>Shop by vehicle or category</h3>'+a.map(ae).join("")+"</section>"),r.length&&(o+='<section class="integy-v433-search-products" aria-label="Products"><h3>Products</h3><div class="integy-v426-search-suggestions">'+r.map(ie).join("")+"</div></section>"),o+=r.length||a.length?'<a class="integy-v426-search-all" href="'+y(G(t))+'">View all products for “'+y(t)+'”</a>':'<div class="integy-v426-search-empty">No quick matches. <a href="'+y(G(t))+'">Search all products</a></div>',c.innerHTML=o,X(c),ne(c)}}function ce(e){var r=f(e.value);if(r.length<2)Z();else{var a=++i;!function(e){n=e,W(e),K().hidden=!1,t.classList.add("integy-v426-search-open","integy-v431-search-open")}(e),K().innerHTML='<div class="integy-v426-search-loading" role="status">Searching…</div>';var s=j(r).catch(function(){return[]});s.then(function(t){t.length&&se(e,r,t,[],a)}),H(r).then(function(t){return s.then(function(n){se(e,r,n.concat(t.products||[]),t.collections||[],a)})}).catch(function(){return null})}}function oe(e,t){return'<article class="integy-v426-search-card integy-v431-search-card"><a class="integy-v426-search-card__image" href="'+y(e.url)+'">'+Y(e,t,"integy-v426-search-card__media")+'</a><div class="integy-v426-search-card__body"><h2><a href="'+y(e.url)+'">'+y(e.title)+"</a></h2>"+(e.sku?'<div class="integy-v426-search-card__sku">SKU: '+y(e.sku)+"</div>":"")+(storefrontType(e)?'<div class="integy-v426-search-card__type">'+y(storefrontType(e))+"</div>":"")+(""!==e.price?'<div class="integy-v426-search-card__price"><span>'+y(Q(e.price))+"</span></div>":"")+(!0===e.available?'<div class="integy-v456-search-stock is-in-stock">In stock</div>':!1===e.available?'<div class="integy-v456-search-stock is-sold-out">Sold out</div>':"")+'<a class="integy-v426-search-card__action" href="'+y(e.url)+'">View Details</a></div></article>'}function ue(){return g(".search--section .productgrid--sidebar,.search--section .productgrid--items,.search--section .productgrid--no-results,.search--section .productgrid--footer,.search--section .pagination--container,.search--section .pagination,.search--section .productgrid--wrapper > .productgrid--filters,.search--section .productgrid--wrapper > .productgrid--utils-sticky-intersection,.search--section .productgrid--wrapper > .productgrid--utils-container")}function le(){ue().forEach(function(e){e.hidden=!1,e.removeAttribute("aria-hidden")});var e=document.getElementById("integy-v426-search-results");e&&(e.hidden=!0,e.innerHTML="");var r=h(".search--section .productgrid--outer");r&&r.classList.remove("integy-v431-search-outer"),t.classList.remove("integy-v426-fast-results-ready","integy-v431-fast-results-ready","integy-v431-fast-search-pending")}function de(){var e=window.Theme&&Theme.routes&&Theme.routes.search_url||"/search";if(location.pathname===e||/\/search\/?$/.test(location.pathname)){var r=new URLSearchParams(location.search);if("1"===r.get("integy_fast")){var n=f(r.get("q"));if(n.length<3)le();else{var i=function(){var e=document.getElementById("integy-v426-search-results");if(e)return e;(e=document.createElement("section")).id="integy-v426-search-results",e.className="integy-v426-search-results integy-v431-search-results integy-v437-search-results",e.hidden=!0;var t=h(".productgrid--wrapper")||h("main"),r=t&&h(".productgrid--masthead",t);return t&&t.insertBefore(e,r?r.nextSibling:t.firstChild),e}();i?Promise.all([j(n),H(n).catch(function(){return{products:[],collections:[]}})]).then(function(e){var r=e[0]||[],a=e[1]&&e[1].products||[],s=e[1]&&e[1].collections||[],c=refineSkuResults(U(O(g(".productgrid--items [data-product-item],.productgrid--items .productgrid--item").map(function(e){var t=h('a[href*="/products/"]',e),r=h("img",e);return{url:L(t&&t.getAttribute("href")),title:f((h(".productitem--title",e)||{}).textContent),sku:f((h(".integy-product-card-sku",e)||{}).textContent).replace(/^SKU:\s*/i,""),image:C(r&&(r.currentSrc||r.getAttribute("src"))),price:f((h(".integy-v410-card-price__current,.money[data-price]",e)||{}).textContent),type:f((h(".integy-v426-card-type",e)||{}).textContent).replace(/^Type:\s*/i,""),tags:"",description:"",variantSkus:[]}}).concat(r,a),n),n),n),v456Limit=window.matchMedia("(max-width: 740px)").matches?36:window.matchMedia("(max-width: 1100px)").matches?48:72,o=c.slice(0,v456Limit),u=rankCollections(s,n).slice(0,4);if(o.length){var l=u.length?'<section class="integy-v437-search-collections"><h2>Shop by vehicle or category</h2><div>'+u.map(ae).join("")+'</div></section>':"",d=c.length>v456Limit?'Showing '+v456Limit+' of '+c.length+' matches. Add a model, size, or SKU to narrow the results.':c.length+" product"+(1===c.length?"":"s")+" matching “"+y(n)+"”";i.innerHTML=l+'<header class="integy-v426-search-results__header"><h1>'+d+'</h1></header><div class="integy-v426-search-grid" data-result-count="'+o.length+'">'+o.map(oe).join("")+"</div>",i.hidden=!1,X(i),ne(i),ue().forEach(function(e){e.hidden=!0,e.setAttribute("aria-hidden","true")});var m=h(".search--section .productgrid--outer");m&&(m.classList.remove("layout--has-sidebar"),m.classList.add("layout--no-sidebar","integy-v431-search-outer")),function(e,t){var r=(e>v456Limit?"Top "+v456Limit+" products":""+e+" product"+(1===e?"":"s"))+" for “"+t+"”",n=g(".breadcrumbs-container > span");n.length&&(n[n.length-1].textContent=r);var i=(document.title.match(/(\s+[–—|]\s+.+)$/)||[])[1]||"";document.title=r+i}(c.length,n),t.classList.remove("integy-v431-fast-search-pending"),t.classList.add("integy-v426-fast-results-ready","integy-v431-fast-results-ready","integy-v437-fast-results-ready")}else le()}).catch(le):le()}}else t.classList.remove("integy-v431-fast-search-pending")}else t.classList.remove("integy-v431-fast-search-pending")}function he(){g('form[action*="/search"],form[role="search"]').forEach(D),/^\d{3,8}$/.test((new URLSearchParams(location.search)).get("q")||"")||de()}void 0}();

;

/* INTEGY V520 — unified predictive search, contiguous SKU matching, and one submitted-search owner. */
(function () {
  'use strict';

  if (window.IntegyV520SearchOwner) return;

  var root = document.documentElement;
  var api = window.IntegyV508Search || window.IntegyV506Search || {};
  var config = window.INTEGY_V426_SEARCH || {};
  var assetBase = String(config.indexBase || '');
  var placeholder = String(config.placeholder || '');
  var panelId = 'integy-v520-search-panel';
  var resultsId = 'integy-v520-search-results';
  var activeInput = null;
  var inputTimer = 0;
  var requestSerial = 0;
  var jsonCache = Object.create(null);
  var searchPageObserver = null;
  var predictiveController = null;
  var predictiveTimeout = 0;
  var ownedPageState = null;
  var pageRequestSerial = 0;
  var lastOwnedPageKey = '';
  var searchPageInFlight = false;
  var searchPageFinished = false;
  var searchPageDeadline = 0;

  function finishSearchRequest() {
    window.clearTimeout(searchPageDeadline);
    searchPageDeadline = 0;
    searchPageInFlight = false;
    searchPageFinished = true;
  }
  var v617CollectionProductCache = Object.create(null);
  var v618VehicleModelRegistryCache = null;
  var v620RouteIndexCache = Object.create(null);
  var v620RouteHtmlCache = Object.create(null);
  var legacyLocalSearch = api && typeof api.localSearch === 'function'
    ? api.localSearch.bind(api)
    : null;

  function withTimeout(promise, timeoutMs, fallbackValue) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve(fallbackValue);
      }, timeoutMs);
      Promise.resolve(promise).then(function (value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }, function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(fallbackValue);
      });
    });
  }

  function one(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (error) { return null; }
  }

  function all(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  /* INTEGY V626 — Shopify Markets-safe routing and presentment-currency formatting. */
  function v626RootPath() {
    var route = window.Shopify && Shopify.routes && Shopify.routes.root;
    route = String(route || (window.INTEGY_CURRENCY_CONTEXT && INTEGY_CURRENCY_CONTEXT.root) || '/');
    if (!route.startsWith('/')) route = '/';
    return route.replace(/\/+$/, '/') || '/';
  }
  function v626LocalizedPath(path) {
    path = String(path || '');
    if (!path || /^(?:https?:)?\/\//i.test(path) || path.charAt(0) === '#') return path;
    var rootPath = v626RootPath();
    if (path.charAt(0) !== '/') path = '/' + path;
    if (rootPath === '/') return path;
    var rootNoSlash = rootPath.replace(/\/$/, '');
    if (path === rootNoSlash || path.indexOf(rootNoSlash + '/') === 0) return path;
    return rootNoSlash + path;
  }
  function v626CurrencyCode() {
    var context = window.INTEGY_CURRENCY_CONTEXT || {};
    var code = context.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return String(code || 'USD').toUpperCase();
  }
  function v626MoneyFromCents(cents) {
    cents = Number(cents || 0);
    if (!(cents > 0)) return '';
    var code = v626CurrencyCode();
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100); }
    catch (error) { return (window.INTEGY_CURRENCY_CONTEXT && INTEGY_CURRENCY_CONTEXT.symbol || '$') + (cents / 100).toFixed(2); }
  }
  function v626MoneyFromMajor(amount) {
    amount = Number(amount);
    if (!Number.isFinite(amount)) return '';
    var code = v626CurrencyCode();
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount); }
    catch (error) { return (window.INTEGY_CURRENCY_CONTEXT && INTEGY_CURRENCY_CONTEXT.symbol || '$') + amount.toFixed(2); }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function normalizeSku(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function normalizeText(value) {
    return clean(value).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function digitGroups(value) {
    return String(value || '').toUpperCase().match(/\d+/g) || [];
  }

  function recordDigitGroups(record) {
    var values = [record && record.sku || ''].concat(Array.isArray(record && record.variantSkus) ? record.variantSkus : []);
    var seen = Object.create(null);
    var groups = [];
    values.forEach(function (value) {
      digitGroups(value).forEach(function (group) {
        if (!seen[group]) {
          seen[group] = true;
          groups.push(group);
        }
      });
    });
    return groups;
  }

  function numericQuery(value) {
    var query = clean(value);
    return /^\d{3,8}$/.test(query) ? query : '';
  }

  function skuLikeQuery(value) {
    var raw = clean(value);
    var normalized = normalizeSku(raw);
    if (!/[A-Z]/.test(normalized) || !/\d/.test(normalized) || normalized.length < 5) return '';
    var groups = digitGroups(raw).sort(function (left, right) { return right.length - left.length; });
    if (!groups.length || groups[0].length < 3) return '';
    return normalized;
  }

  function numbersForSkuQuery(value) {
    var groups = digitGroups(value);
    var values = [];
    if (groups.length) {
      values.push(groups.slice().sort(function (left, right) { return right.length - left.length; })[0]);
      var joined = groups.join('');
      if (joined && values.indexOf(joined) < 0) values.push(joined);
    }
    return values.filter(function (number) { return number.length >= 3 && number.length <= 8; });
  }

  function specialtyQuery(value) {
    return /(?:prototype|used|open[ -]?box|scratch(?:\s*&\s*|\s+and\s+|[- ])?dent|one[ -]?of[ -]?a[ -]?kind|take[ -]?off|replacement|new[, -]+scratch|like[ -]?new)/i.test(String(value || ''));
  }

  function specialtyLevel(record) {
    if (api && typeof api.specialtyLevel === 'function') {
      return Number(api.specialtyLevel(record)) || 0;
    }
    var text = [record && record.title, record && record.type, record && record.tags, record && record.description, record && record.url]
      .join(' ')
      .toLowerCase();
    if (/(?:used-open-box-scratch-dent|one-of-a-kind-open-box-scratch-dent|one[ -]?of[ -]?a[ -]?kind|open[ -]?box|scratch(?:\s*&\s*|\s+and\s+|[- ])?dent|new[, -]+scratch|like[ -]?new|take[ -]?off|prototype|\bused\b)/i.test(text)) return 3;
    if (/(?:replacement parts?|\breplacement\b)/i.test(text)) return 2;
    return 0;
  }

  function exactSkuQuery(record, query) {
    var normalizedQuery = normalizeSku(query);
    if (!normalizedQuery) return false;
    return [record && record.sku].concat(Array.isArray(record && record.variantSkus) ? record.variantSkus : []).some(function (sku) {
      return normalizeSku(sku) === normalizedQuery;
    });
  }

  function isSearchInput(target) {
    if (!target || !target.matches || !target.matches('input[type="search"],input[name="q"]')) return false;
    var form = target.closest('form');
    return !!(form && (form.matches('form[role="search"]') || String(form.getAttribute('action') || '').indexOf('/search') >= 0));
  }

  function isHeaderSearchInput(target) {
    return isSearchInput(target) && !!target.closest('.live-search');
  }

  function assetUrl(name) {
    var url = assetBase ? assetBase + name : name;
    var version = String(window.INTEGY_SEARCH_SCHEMA_VERSION || 'V520-CENTS-14');
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'v=' + encodeURIComponent(version);
  }

  function fetchJson(name) {
    var url = assetUrl(name);
    if (jsonCache[url]) return jsonCache[url];
    var controller = window.AbortController ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 5200);
    jsonCache[url] = fetch(url, {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'application/json' },
      signal: controller && controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Search index request failed: ' + response.status);
      return response.json();
    }).then(function (data) {
      window.clearTimeout(timeout);
      return data;
    }, function (error) {
      window.clearTimeout(timeout);
      delete jsonCache[url];
      throw error;
    });
    return jsonCache[url];
  }

  function recordFromArray(item) {
    if (!Array.isArray(item) || item.length < 10) return null;
    return {
      sku: String(item[0] || ''),
      title: String(item[1] || ''),
      url: String(item[2] || ''),
      price_cents: Number(item[3]),
      price: Number(item[3]),
      type: String(item[4] || ''),
      variantSkus: Array.isArray(item[5]) ? item[5] : [],
      image: String(item[6] || ''),
      tags: String(item[7] || ''),
      description: String(item[8] || ''),
      available: item[9] === true,
      _source: 'catalog-v520'
    };
  }

  function naturalSkuCompare(left, right) {
    return String(left && left.sku || '').localeCompare(String(right && right.sku || ''), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

  function dedupeProducts(records) {
    var seen = Object.create(null);
    return (records || []).filter(function (record) {
      if (!record) return false;
      var sku = normalizeSku(record.sku);
      var url = clean(record.url).toLowerCase();
      var key = sku ? 'sku:' + sku : url ? 'url:' + url : 'title:' + clean(record.title).toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function numericIndex(query) {
    query = numericQuery(query);
    if (!query) return Promise.resolve(null);
    return fetchJson('integy-v456-search-number-' + query.slice(0, 3) + '.json');
  }

  function recordsFromExactMap(index, query, prefixMode) {
    var records = [];
    var exact = index && index.exact && typeof index.exact === 'object' ? index.exact : {};
    Object.keys(exact).forEach(function (key) {
      if (prefixMode ? key.indexOf(query) !== 0 : key !== query) return;
      (exact[key] || []).forEach(function (item) {
        var record = recordFromArray(item);
        if (!record) return;
        var groups = recordDigitGroups(record);
        var valid = groups.some(function (group) {
          return prefixMode ? group.indexOf(query) === 0 : group === query;
        });
        if (valid) records.push(record);
      });
    });
    return dedupeProducts(records).sort(function (left, right) {
      var leftGroups = recordDigitGroups(left);
      var rightGroups = recordDigitGroups(right);
      var leftExact = leftGroups.indexOf(query) >= 0 ? 0 : 1;
      var rightExact = rightGroups.indexOf(query) >= 0 ? 0 : 1;
      if (leftExact !== rightExact) return leftExact - rightExact;
      var leftLength = Math.min.apply(Math, leftGroups.filter(function (group) { return group.indexOf(query) === 0; }).map(function (group) { return group.length; }).concat([99]));
      var rightLength = Math.min.apply(Math, rightGroups.filter(function (group) { return group.indexOf(query) === 0; }).map(function (group) { return group.length; }).concat([99]));
      if (leftLength !== rightLength) return leftLength - rightLength;
      if (left.available !== right.available) return left.available ? -1 : 1;
      return naturalSkuCompare(left, right);
    });
  }

  /* INTEGY V695 — current numeric search indexes are compact {ids:[...]} maps,
     not the older {exact:{...}} schema. Resolve those catalog IDs directly so
     numeric-only SKU searches such as 34067 and 26399 do not depend on Shopify
     native search or a broad full-catalog fallback. */
  function recordsFromNumericIdIndex(index, query, prefixMode) {
    var ids = index && Array.isArray(index.ids) ? index.ids.map(function (value) { return Number(value); }).filter(function (value) { return Number.isFinite(value) && value >= 0; }) : [];
    if (!ids.length) return Promise.resolve([]);
    var byChunk = Object.create(null);
    ids.forEach(function (id) {
      var chunk = Math.floor(id / 256);
      (byChunk[chunk] || (byChunk[chunk] = [])).push(id);
    });
    var chunks = Object.keys(byChunk).map(Number).sort(function (a, b) { return a - b; });
    function filterRecords(records) {
      records = dedupeProducts(records || []).filter(function (record) {
        return recordDigitGroups(record).some(function (group) {
          return prefixMode ? group.indexOf(query) === 0 : group === query;
        });
      });
      return records.sort(function (left, right) {
        var leftGroups = recordDigitGroups(left), rightGroups = recordDigitGroups(right);
        var leftExact = leftGroups.indexOf(query) >= 0 ? 0 : 1;
        var rightExact = rightGroups.indexOf(query) >= 0 ? 0 : 1;
        if (leftExact !== rightExact) return leftExact - rightExact;
        if (left.available !== right.available) return left.available ? -1 : 1;
        return naturalSkuCompare(left, right);
      });
    }
    if (chunks.length > 44 || ids.length > 2200) {
      return fetchJson('integy-v456-search-catalog-full.json').then(function (data) {
        var items = data && Array.isArray(data.items) ? data.items : [];
        return filterRecords(ids.map(function (id) { return recordFromArray(items[id]); }).filter(Boolean));
      });
    }
    return Promise.all(chunks.map(function (chunk) {
      return fetchJson('integy-v456-search-catalog-' + ('000' + chunk).slice(-3) + '.json');
    })).then(function (payloads) {
      var recordsById = Object.create(null);
      payloads.forEach(function (payload) {
        if (!payload || !Array.isArray(payload.items)) return;
        var offset = Number(payload.offset) || 0;
        payload.items.forEach(function (item, index) {
          var id = offset + index;
          recordsById[id] = recordFromArray(item);
        });
      });
      return filterRecords(ids.map(function (id) { return recordsById[id]; }).filter(Boolean));
    });
  }

  function exactNumericSearch(query) {
    query = numericQuery(query);
    if (!query || query.length < 4) return Promise.resolve([]);
    return withTimeout(numericIndex(query), 5600, null).then(function (index) {
      var records = recordsFromExactMap(index, query, false);
      if (records.length) return records;
      return withTimeout(recordsFromNumericIdIndex(index, query, false), 5600, []).then(function (idRecords) {
        if (idRecords.length) return idRecords;
        if (!legacyLocalSearch) return [];
        return withTimeout(legacyLocalSearch(query), 5600, []).then(function (fallback) {
          return dedupeProducts((fallback || []).filter(function (record) {
            return recordDigitGroups(record).indexOf(query) >= 0;
          })).sort(naturalSkuCompare);
        });
      });
    }).catch(function () { return []; });
  }

  function numericPrefixSearch(query) {
    query = numericQuery(query);
    if (!query) return Promise.resolve([]);
    return withTimeout(numericIndex(query), 5600, null).then(function (index) {
      var legacy = recordsFromExactMap(index, query, true);
      if (legacy.length) return legacy;
      return withTimeout(recordsFromNumericIdIndex(index, query, true), 5600, []);
    }).catch(function () { return []; });
  }

  function exactSkuSearch(query) {
    var normalizedQuery = skuLikeQuery(query);
    if (!normalizedQuery) return Promise.resolve([]);
    var searches = [];
    numbersForSkuQuery(query).forEach(function (number) {
      searches.push(numericIndex(number).then(function (index) {
        var candidates = [];
        var exact = index && index.exact && typeof index.exact === 'object' ? index.exact : {};
        Object.keys(exact).forEach(function (key) {
          (exact[key] || []).forEach(function (item) {
            var record = recordFromArray(item);
            if (record) candidates.push(record);
          });
        });
        return candidates;
      }).catch(function () { return []; }));
    });
    if (api && typeof api.localSearch === 'function') {
      searches.push(api.localSearch(query).catch(function () { return []; }));
    }
    return Promise.all(searches).then(function (sets) {
      var candidates = [];
      sets.forEach(function (set) { candidates = candidates.concat(set || []); });
      return dedupeProducts(candidates.filter(function (record) {
        var skus = [record && record.sku || ''].concat(Array.isArray(record && record.variantSkus) ? record.variantSkus : []);
        return skus.some(function (sku) {
          var normalizedSku = normalizeSku(sku);
          return normalizedSku === normalizedQuery || normalizedSku.indexOf(normalizedQuery) === 0;
        });
      })).sort(naturalSkuCompare);
    });
  }

  function safeProductUrl(record) {
    var url = String(record && record.url || '');
    var match = url.match(/\/products\/([a-z0-9][a-z0-9-]*)(?:[?#]|$)/i);
    return match
      ? v626LocalizedPath('/products/' + match[1])
      : v626LocalizedPath('/search') + '?q=' + encodeURIComponent(record && record.sku || '');
  }

  function priceText(record) {
    /* V41/local catalog cents are USD source data. Never label them as another
       presentment currency. Non-USD cards wait for locale-aware product JSON. */
    if (record && Number.isFinite(Number(record.price_cents))) {
      if (v626CurrencyCode() !== 'USD' && /catalog|index/i.test(String(record._source || ''))) return '';
      return v626MoneyFromCents(Number(record.price_cents));
    }
    var value = clean(record && record.price);
    if (!value) return '';
    /* Native HTML/predictive values are already formatted in presentment currency. */
    if (/[^0-9.,\s-]/.test(value)) return value;
    var number = Number(value.replace(/,/g, ''));
    if (!Number.isFinite(number)) return value;
    if (/^\d+$/.test(value) || (record && /catalog/i.test(String(record._source || '')))) {
      if (v626CurrencyCode() !== 'USD' && /catalog/i.test(String(record._source || ''))) return '';
      return v626MoneyFromCents(number);
    }
    return v626MoneyFromMajor(number);
  }

  function imageSource(record) {
    var source = clean(record && record.image);
    /* INTEGY V605 — the V41 catalog image index points at the legacy Integy
       firewall host. That host can reject storefront/hotlink requests, leaving
       white image boxes. Use the local placeholder until Shopify product JSON
       supplies the canonical CDN image. */
    if (source && /ssl-firewall-[^/]*\.integy\.com/i.test(source)) return placeholder || source;
    return source || placeholder;
  }

  /* INTEGY V604 — strict multi-word product relevance.
     Candidate indexes are intentionally prefix-based, and Shopify native/predictive
     results are merged afterward. For a multi-word name/part query, require every
     meaningful query token to exist somewhere in the product's searchable metadata
     before ranking. Single-word, SKU-like, and numeric searches retain V603 behavior. */
  var v604SearchStopwords = {
    the: 1, for: 1, with: 1, and: 1, from: 1, into: 1, all: 1, set: 1, kit: 1,
    part: 1, parts: 1, integy: 1, machined: 1, billet: 1, upgrade: 1, upgrades: 1,
    rc: 1, of: 1, to: 1, or: 1, by: 1, on: 1
  };

  function v604StemSearchToken(token) {
    token = String(token || '').toLowerCase();
    var irregular = {
      bodies: 'body', batteries: 'battery', batteries: 'battery',
      tires: 'tire', tyres: 'tire', wheels: 'wheel', shocks: 'shock',
      towers: 'tower', arms: 'arm', gears: 'gear', pinions: 'pinion',
      spurs: 'spur', servos: 'servo', horns: 'horn', savers: 'saver',
      wrenches: 'wrench', tips: 'tip', drivers: 'driver', bearings: 'bearing',
      springs: 'spring', links: 'link', rods: 'rod', skids: 'skid', plates: 'plate',
      trays: 'tray', hubs: 'hub', knuckles: 'knuckle', carriers: 'carrier',
      differentials: 'differential', gearboxes: 'gearbox', transmissions: 'transmission',
      connectors: 'connector', plugs: 'plug', receivers: 'receiver', radios: 'radio',
      controllers: 'controller', screws: 'screw', nuts: 'nut', adapters: 'adapter',
      stations: 'station', heatsinks: 'heatsink', covers: 'cover', cages: 'cage',
      racks: 'rack', turnbuckles: 'turnbuckle'
    };
    if (irregular[token]) return irregular[token];
    if (token.length > 4 && /ies$/.test(token)) return token.slice(0, -3) + 'y';
    if (token.length > 4 && /(?:ches|shes|xes|zes|ses)$/.test(token)) return token.slice(0, -2);
    if (token.length > 3 && /s$/.test(token) && !/(?:ss|us|is)$/.test(token)) return token.slice(0, -1);
    return token;
  }

  function v604MeaningfulSearchTokens(query) {
    var seen = Object.create(null);
    return normalizeText(query).split(' ').filter(function (token) {
      if (token.length < 2 || v604SearchStopwords[token]) return false;
      token = v604StemSearchToken(token);
      if (!token || seen[token]) return false;
      seen[token] = true;
      return true;
    }).map(v604StemSearchToken);
  }

  function v604TokenSet(value) {
    var set = Object.create(null);
    normalizeText(value).split(' ').forEach(function (token) {
      if (!token) return;
      set[token] = true;
      set[v604StemSearchToken(token)] = true;
    });
    return set;
  }

  function v604MultiWordCoverage(record, query) {
    if (numericQuery(query) || skuLikeQuery(query)) return { ok: true, count: 0, titleAll: false };
    var tokens = v604MeaningfulSearchTokens(query);
    if (tokens.length < 2) return { ok: true, count: tokens.length, titleAll: false };
    var searchable = [
      record && record.title, record && record.type, record && record.tags,
      record && record.description, record && record.url, record && record.compatibility
    ].join(' ');
    var allTokens = v604TokenSet(searchable);
    var ok = tokens.every(function (token) { return !!allTokens[token]; });
    if (!ok) return { ok: false, count: tokens.length, titleAll: false };
    var titleTokens = v604TokenSet(record && record.title || '');
    return {
      ok: true,
      count: tokens.length,
      titleAll: tokens.every(function (token) { return !!titleTokens[token]; })
    };
  }

  function productScore(record, query) {
    var coverage = v604MultiWordCoverage(record, query);
    if (!coverage.ok) return -100000;
    var queryText = normalizeText(query);
    var querySku = normalizeSku(query);
    var sku = normalizeSku(record && record.sku);
    var title = normalizeText(record && record.title);
    var type = normalizeText(record && record.type);
    var tags = normalizeText(record && record.tags);
    var compatibility = normalizeText(record && record.compatibility);
    var score = 0;
    if (sku && querySku) {
      if (sku === querySku) score += 12000;
      else if (sku.indexOf(querySku) === 0) score += 9000;
      else if (sku.indexOf(querySku) >= 0) score += 2500;
    }
    var numeric = numericQuery(query);
    if (numeric) {
      var groups = recordDigitGroups(record);
      if (groups.indexOf(numeric) >= 0) score += 11000;
      else if (groups.some(function (group) { return group.indexOf(numeric) === 0; })) score += 8000;
      else return -100000;
    }
    if (title === queryText) score += 5000;
    else if (title.indexOf(queryText) === 0) score += 2800;
    else if (title.indexOf(queryText) >= 0) score += 1200;
    if (type === queryText) score += 2200;
    else if (type.indexOf(queryText) === 0) score += 900;
    if (tags.indexOf(queryText) >= 0) score += 250;
    if (compatibility.indexOf(queryText) >= 0) score += 700;
    var tokens = queryText.split(' ').filter(function (token) { return token.length > 1; });
    tokens.forEach(function (token) {
      if (title.indexOf(token) >= 0) score += 180;
      if (type.indexOf(token) >= 0) score += 120;
      if (tags.indexOf(token) >= 0) score += 40;
      if (compatibility.indexOf(token) >= 0) score += 90;
    });
    if (coverage.count >= 2) score += coverage.titleAll ? 1200 : 300;
    /* V719: availability is a ranking tie-breaker, never evidence of relevance. */
    if (score <= 0) return -100000;
    if (specialtyLevel(record) >= 3 && !specialtyQuery(query) && !exactSkuQuery(record, query)) score -= 6000;
    if (record && record.available === true) score += 20;
    return score;
  }

  /* INTEGY V630 — availability-first submitted search.
     Exact SKU lookups stay exact even when that SKU is sold out. For ordinary searches,
     relevant in-stock products are grouped ahead of sold-out matches so queries such as
     "outcast tower" do not lead with unavailable products. */
  function v630AvailabilityRank(record) {
    if (record && record.available === true) return 0;
    if (record && record.available === false) return 2;
    return 1;
  }

  function rankProducts(records, query) {
    return dedupeProducts(records).map(function (record, index) {
      return {
        record: record,
        score: productScore(record, query),
        exactSku: exactSkuQuery(record, query) ? 0 : 1,
        availability: v630AvailabilityRank(record),
        index: index
      };
    }).filter(function (entry) {
      return entry.score > -100000;
    }).sort(function (left, right) {
      return left.exactSku - right.exactSku ||
        left.availability - right.availability ||
        right.score - left.score ||
        naturalSkuCompare(left.record, right.record) ||
        left.index - right.index;
    }).map(function (entry) { return entry.record; });
  }

  function fetchPredictive(query) {
    if (predictiveController) {
      try { predictiveController.abort(); } catch (error) {}
    }
    window.clearTimeout(predictiveTimeout);
    predictiveController = window.AbortController ? new AbortController() : null;
    var route = window.Theme && Theme.routes && Theme.routes.predictive_search_url || v626LocalizedPath('/search/suggest');
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('section_id', 'predictive-search');
    params.set('resources[type]', 'product,collection');
    params.set('resources[limit]', '10');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'show');
    params.set('resources[options][fields]', 'title,product_type,variants.sku,tag');
    if (predictiveController) predictiveTimeout = window.setTimeout(function () { predictiveController.abort(); }, 4200);
    return withTimeout(fetch(route + '?' + params.toString(), {
      credentials: 'same-origin',
      signal: predictiveController && predictiveController.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Predictive search unavailable');
      return response.text();
    }).then(function (html) {
      return api && typeof api.parsePredictive === 'function'
        ? api.parsePredictive(html)
        : { products: [], collections: [] };
    }).catch(function () {
      return { products: [], collections: [] };
    }).then(function (result) {
      window.clearTimeout(predictiveTimeout);
      return result;
    }), 5000, { products: [], collections: [] });
  }

  /* INTEGY V613 — compatibility supplement layer.
     Search-token files remain the fast primary index. This small, extensible manifest
     supplies products whose Shopify model-collection membership is authoritative even
     when the model name is absent from title/type/tags. */
  function v613PadChunk(value) {
    return ('000' + String(value)).slice(-3);
  }

  function v613CompatProfiles(query) {
    var normalized = normalizeText(query);
    if (!normalized || normalized.length < 3) return Promise.resolve([]);
    return fetchJson('integy-v613-search-compat.json').then(function (data) {
      return (data && Array.isArray(data.profiles) ? data.profiles : []).filter(function (profile) {
        var matches = Array.isArray(profile && profile.match) ? profile.match : [];
        return matches.some(function (alias) {
          alias = normalizeText(alias);
          if (!alias) return false;
          return normalized === alias || (' ' + normalized + ' ').indexOf(' ' + alias + ' ') >= 0;
        });
      });
    }).catch(function () { return []; });
  }

  function v613CompatRecords(query) {
    return v613CompatProfiles(query).then(function (profiles) {
      if (!profiles.length) return [];
      var byChunk = Object.create(null);
      profiles.forEach(function (profile) {
        (profile.ids || []).forEach(function (rawId) {
          var id = Number(rawId);
          if (!Number.isFinite(id) || id < 0) return;
          var chunk = Math.floor(id / 256);
          (byChunk[chunk] || (byChunk[chunk] = [])).push({ id: id, profile: profile });
        });
      });
      var chunks = Object.keys(byChunk).map(Number);
      return Promise.all(chunks.map(function (chunk) {
        return fetchJson('integy-v456-search-catalog-' + v613PadChunk(chunk) + '.json').then(function (data) {
          var offset = Number(data && data.offset) || 0;
          var items = data && Array.isArray(data.items) ? data.items : [];
          return (byChunk[chunk] || []).map(function (entry) {
            var record = recordFromArray(items[entry.id - offset]);
            if (!record) return null;
            record.compatibility = clean(entry.profile && entry.profile.compatibility || '');
            record._source = 'catalog-v613-compat';
            return record;
          }).filter(Boolean);
        }).catch(function () { return []; });
      })).then(function (sets) {
        var records = [];
        sets.forEach(function (set) { records = records.concat(set || []); });
        return dedupeProducts(records);
      });
    });
  }

  /* INTEGY V625 — exact standalone metric-size search.
     The legacy tokenizer intentionally ignores digit-leading word tokens, which made
     a query such as "4.8mm" depend almost entirely on Shopify predictive search.
     V625 adds a compact exact-dimension manifest built from the V41/V456 catalog. */
  function v625DimensionKey(query) {
    var match = clean(query).toLowerCase().match(/^(\d{1,2})(?:[\.,](\d))?\s*(?:m\s*m|mm)$/i);
    if (!match) return '';
    var value = Number(match[1] + (match[2] ? '.' + match[2] : ''));
    return Number.isFinite(value) && value > 0 && value <= 10 ? String(Math.round(value * 10)) : '';
  }

  function v625DimensionRecords(query) {
    var key = v625DimensionKey(query);
    if (!key) return Promise.resolve([]);
    return fetchJson('integy-v625-search-dimensions.json').then(function (data) {
      var ids = data && data.dimensions && Array.isArray(data.dimensions[key]) ? data.dimensions[key] : [];
      if (!ids.length) return [];
      var byChunk = Object.create(null);
      ids.forEach(function (rawId) {
        var id = Number(rawId);
        if (!Number.isFinite(id) || id < 0) return;
        var chunk = Math.floor(id / 256);
        (byChunk[chunk] || (byChunk[chunk] = [])).push(id);
      });
      return Promise.all(Object.keys(byChunk).map(function (rawChunk) {
        var chunk = Number(rawChunk);
        return fetchJson('integy-v456-search-catalog-' + v613PadChunk(chunk) + '.json').then(function (catalog) {
          var offset = Number(catalog && catalog.offset) || 0;
          var chunkItems = catalog && Array.isArray(catalog.items) ? catalog.items : [];
          return (byChunk[chunk] || []).map(function (id) {
            var record = recordFromArray(chunkItems[id - offset]);
            if (record) {
              record.compatibility = clean((record.compatibility || '') + ' ' + query);
              record._source = 'catalog-v625-dimension';
            }
            return record;
          }).filter(Boolean);
        }).catch(function () { return []; });
      })).then(function (sets) {
        var records = [];
        sets.forEach(function (set) { records = records.concat(set || []); });
        return dedupeProducts(records);
      });
    }).catch(function () { return []; });
  }

  var v712DeltaCatalogPromise = null;
  function v712DeltaCatalog() {
    if (!v712DeltaCatalogPromise) {
      v712DeltaCatalogPromise = fetchJson('integy-v712-v47-delta.json').then(function (data) {
        return (data && Array.isArray(data.items) ? data.items : []).map(recordFromArray).filter(Boolean);
      }).catch(function () { return []; });
    }
    return v712DeltaCatalogPromise;
  }

  function v712DeltaSearch(query) {
    return v712DeltaCatalog().then(function (records) {
      return rankProducts(records || [], query);
    });
  }

  function localSearch(query) {
    var primary = legacyLocalSearch
      ? withTimeout(legacyLocalSearch(query), 5600, [])
      : Promise.resolve([]);
    return Promise.all([
      primary,
      withTimeout(v613CompatRecords(query), 5600, []),
      withTimeout(v625DimensionRecords(query), 5600, []),
      withTimeout(v712DeltaSearch(query), 2200, [])
    ]).then(function (sets) {
      return dedupeProducts((sets[3] || []).concat(sets[2] || [], sets[1] || [], sets[0] || []));
    });
  }

  /* INTEGY V617 — exact vehicle/model searches are collection-authoritative.
     The old three-character token index remains ideal for generic part/SKU discovery,
     but it is intentionally broad for model names (for example TRX-4 -> trx). When a
     short model-like query has a strong collection match from Shopify predictive search,
     load that collection page-by-page and use its full product membership as the result
     universe. Ranking may reorder those products, but it may not discard compatible
     members merely because the model name is absent from the product title/tags. */
  var v617PartWords = {
    arm:1, axle:1, battery:1, bearing:1, body:1, brace:1, bumper:1, cage:1,
    carrier:1, chassis:1, connector:1, cover:1, differential:1, driver:1,
    esc:1, fan:1, gear:1, gearbox:1, heatsink:1, horn:1, hub:1, knuckle:1,
    led:1, light:1, link:1, mount:1, nut:1, pinion:1, plate:1, radio:1,
    receiver:1, rod:1, saver:1, screw:1, servo:1, shaft:1, shock:1, skid:1,
    spring:1, spur:1, tire:1, tower:1, tray:1, turnbuckle:1, wheel:1, wrench:1,
    tip:1, tool:1, adapter:1, kit:1
  };

  function v617LikelyModelQuery(query) {
    var normalized = normalizeText(query);
    if (!normalized || normalized.length < 2 || normalized.length > 36) return false;
    if (numericQuery(query)) return false;
    var tokens = normalized.split(' ').filter(Boolean);
    if (!tokens.length || tokens.length > 4) return false;
    if (tokens.some(function (token) { return !!v617PartWords[v604StemSearchToken(token)]; })) return false;
    if (/\d/.test(normalized)) return true;
    return /^(?:xrt|slash|wraith|lasernut|felony|kraton|outcast|capra|ryft|raminator|maxx|summit|revo|rustler|stampede|bandit|bronco|defender)$/i.test(normalized);
  }

  function v617BestModelCollection(query, collections) {
    if (!v617LikelyModelQuery(query)) return null;
    var ranked = rankCollections(collections || [], query);
    if (!ranked.length) return null;
    var best = ranked[0];
    var score = collectionScore(best, query);
    if (score < 1600) return null;
    var handle = collectionHandle(best);
    if (!handle || /^(?:all|frontpage|catalog|all-products)$/i.test(handle)) return null;
    return best;
  }

  function v617ProductRecord(product, query, collection) {
    if (!product || !product.handle) return null;
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var variantSkus = variants.map(function (variant) { return clean(variant && variant.sku); }).filter(Boolean);
    var firstSku = variantSkus[0] || '';
    var prices = variants.map(function (variant) {
      var value = Number(String(variant && variant.price || '').replace(/,/g, ''));
      return Number.isFinite(value) ? value : null;
    }).filter(function (value) { return value != null; });
    var minPrice = prices.length ? Math.min.apply(Math, prices) : null;
    var image = '';
    if (Array.isArray(product.images) && product.images.length) {
      var firstImage = product.images[0];
      image = clean(typeof firstImage === 'string' ? firstImage : firstImage && (firstImage.src || firstImage.url));
    }
    if (!image && product.image) image = clean(product.image.src || product.image.url || product.image);
    var available = variants.length ? variants.some(function (variant) { return variant && variant.available !== false; }) : !!product.available;
    var tags = Array.isArray(product.tags) ? product.tags.join(' ') : clean(product.tags);
    var compat = [query, collectionDisplayTitle(collection), collectionHandle(collection).replace(/-/g, ' ')].join(' ');
    return {
      url: v626LocalizedPath('/products/' + product.handle),
      title: clean(product.title),
      sku: firstSku,
      image: image,
      price: minPrice == null ? '' : v626MoneyFromMajor(minPrice),
      type: clean(product.product_type || product.type),
      tags: tags,
      description: clean(String(product.body_html || '').replace(/<[^>]*>/g, ' ')),
      variantSkus: variantSkus,
      available: available,
      compatibility: compat,
      _source: 'shopify-model-collection-v617'
    };
  }

  function v617FetchCollectionProducts(collection, query) {
    var handle = collectionHandle(collection);
    if (!handle) return Promise.resolve([]);
    if (v617CollectionProductCache[handle]) {
      return Promise.resolve(v617CollectionProductCache[handle].map(function (record) {
        var copy = {};
        Object.keys(record).forEach(function (key) { copy[key] = record[key]; });
        copy.compatibility = [copy.compatibility || '', query].join(' ');
        return copy;
      }));
    }
    var collected = [];
    function loadPage(page) {
      if (page > 12) return Promise.resolve(collected);
      var url = v626LocalizedPath('/collections/' + encodeURIComponent(handle) + '/products.json') + '?limit=250&page=' + page;
      return withTimeout(fetch(url, { credentials: 'same-origin', cache: 'force-cache' }).then(function (response) {
        if (!response.ok) throw new Error('Collection products unavailable');
        return response.json();
      }), 6500, null).then(function (data) {
        var products = data && Array.isArray(data.products) ? data.products : [];
        products.forEach(function (product) {
          var record = v617ProductRecord(product, query, collection);
          if (record) collected.push(record);
        });
        if (products.length < 250) return collected;
        return loadPage(page + 1);
      });
    }
    return loadPage(1).then(function (records) {
      records = dedupeProducts(records || []);
      if (records.length) v617CollectionProductCache[handle] = records;
      return records;
    }).catch(function () { return []; });
  }

  function v617AuthoritativeModelSearch(query, collections) {
    var collection = v617BestModelCollection(query, collections);
    if (!collection) return Promise.resolve(null);
    return v617FetchCollectionProducts(collection, query).then(function (records) {
      if (!records.length) return null;
      return { collection: collection, records: records };
    });
  }

  /* INTEGY V618 — exhaustive menu-backed vehicle model registry.
     V617 still depended on a model-name heuristic plus predictive search, which meant
     legitimate menu models without digits (Cero Touring, Enduro Sendero, Hellfire,
     Blitz, Firestorm, Baja Rey, TNX, etc.) could fall back to broad text search.
     V618 treats every actual For Your Vehicle model link as an authoritative alias.
     Pure model collections are loaded directly; filtered/master links remain visible
     as collection suggestions and safely fall back to the normal indexed search. */
  function v618StripScale(value) {
    return clean(value).replace(/^\s*\d+\s*\/\s*\d+\s+/, '').trim();
  }

  function v618PushAlias(list, value) {
    var normalized = normalizeText(value);
    if (!normalized || normalized.length < 2 || list.indexOf(normalized) >= 0) return;
    list.push(normalized);
  }

  function v618BrandLabel(anchor) {
    if (!anchor) return '';
    var desktopPanel = anchor.closest && anchor.closest('.integy-v547-vehicle-model-panel');
    var desktopHeading = desktopPanel && one('header h3', desktopPanel);
    if (desktopHeading) return clean(desktopHeading.textContent).replace(/^For\s+/i, '');
    var mobileBrand = anchor.closest && anchor.closest('.integy-v547-mobile-brand');
    var mobileSummary = mobileBrand && one('summary', mobileBrand);
    if (mobileSummary) return clean(mobileSummary.textContent).replace(/\+\s*$/, '').replace(/^For\s+/i, '');
    return '';
  }

  function v618ModelAliases(label, brand) {
    var aliases = [];
    var raw = clean(label);
    var noScale = v618StripScale(raw);
    var noParen = noScale.replace(/\s*\([^)]*\)\s*$/g, '').trim();
    function push(value) { v618PushAlias(aliases, value); }
    [raw, noScale, noParen].forEach(push);

    /* V620: retain V618's useful reductions, but make them cascade far enough for
       names such as Big Rock 4X4 V3 3S and Granite 4WD V3 3S. */
    var reductions = [noParen];
    function addReduction(value) {
      value = clean(value);
      if (!value || reductions.indexOf(value) >= 0) return;
      reductions.push(value);
      push(value);
    }
    for (var pass = 0; pass < 5; pass += 1) {
      reductions.slice().forEach(function (value) {
        addReduction(value.replace(/\s+(?:BLX|RTR)$/i, ''));
        addReduction(value.replace(/\s+(?:Drag Racer|Rock Racer|Scale(?: and| &) Trail Crawler|Crawler|Buggy|Touring)$/i, ''));
        addReduction(value.replace(/\s+(?:Non[- ]LCG|LCG|BL[- ]?2s|EHD)$/i, ''));
        addReduction(value.replace(/\s+w\/?WideMaxx$/i, ''));
        addReduction(value.replace(/\s+(?:4X4|4WD|2WD)$/i, ''));
        addReduction(value.replace(/\s+\d+S$/i, ''));
        addReduction(value.replace(/\s+V\d+$/i, ''));
      });
    }

    /* V620: compound menu labels need intelligent aliases. V618's simple split
       produced junk such as "2nd" and "3.0", while missing customer searches such
       as Bullet ST, RS4 2nd, Jato 3.3, RC10 T4 and XRAY T4. */
    var parts = noScale.split(/\s+(?:\/|&)\s+/).map(clean).filter(Boolean);
    if (parts.length > 1) {
      var firstTokens = parts[0].split(/\s+/).filter(Boolean);
      var inheritedPrefix = firstTokens.length > 1 ? firstTokens.slice(0, -1).join(' ') : '';
      if (inheritedPrefix.length < 3) inheritedPrefix = '';
      parts.forEach(function (part, index) {
        var normalizedPart = normalizeText(part);
        var hasLetter = /[a-z]/i.test(part);
        var looksBareVersion = /^(?:\d+(?:\.\d+)?|\d+(?:st|nd|rd|th))\b/i.test(part);
        var tooGeneric = /^(?:st|mt|tc|pro|gen|rtr|evo|rally|crawler|buggy|touring)$/i.test(part);
        if (hasLetter && normalizedPart.length >= 3 && !tooGeneric && !looksBareVersion) push(part);
        if (index > 0 && inheritedPrefix) {
          var inherited = inheritedPrefix + ' ' + part;
          push(inherited);
          push(inherited.replace(/\s+(?:Buggy|Crawler|Touring)$/i, ''));
        }
      });
    }

    var brandClean = clean(brand).replace(/^For\s+/i, '');
    if (brandClean) {
      aliases.slice().forEach(function (alias) { push(brandClean + ' ' + alias); });
    }
    return aliases;
  }

  function v618VehicleModelRegistry() {
    if (v618VehicleModelRegistryCache && v618VehicleModelRegistryCache.length) return v618VehicleModelRegistryCache;
    var anchors = all('[data-integy-v547-vehicle-meganav] .integy-v547-vehicle-model-grid a, .integy-v547-mobile-models a');
    var seen = Object.create(null);
    var registry = [];
    anchors.forEach(function (anchor) {
      var label = clean(anchor.textContent);
      var href = clean(anchor.getAttribute('href'));
      if (!label || !href || /^View all\b/i.test(label) || /^All .*hop-up parts$/i.test(label)) return;
      var key = label.toLowerCase() + '|' + href;
      if (seen[key]) return;
      seen[key] = true;
      registry.push({
        label: label,
        url: href,
        brand: v618BrandLabel(anchor),
        aliases: v618ModelAliases(label, v618BrandLabel(anchor))
      });
    });
    v618VehicleModelRegistryCache = registry;
    return registry;
  }

  /* INTEGY V625 — exact brand searches get an authoritative collection shortcut.
     Product ranking remains catalog-based (important for very large brands), but the
     matching View-all brand collection is injected ahead of Shopify predictive results. */
  function v625BrandCollections(query) {
    if (numericQuery(query)) return [];
    var q = normalizeText(query);
    if (!q || q.length < 2) return [];
    var anchors = all('[data-integy-v547-vehicle-meganav] .integy-v547-vehicle-model-panel > header a, .integy-v547-mobile-brand a');
    var seen = Object.create(null);
    var results = [];
    anchors.forEach(function (anchor) {
      var text = clean(anchor.textContent);
      if (!/^View all\s+/i.test(text)) return;
      var href = clean(anchor.getAttribute('href'));
      if (!href) return;
      var brand = text.replace(/^View all\s+/i, '').replace(/\s+(?:hop-up\s+)?parts.*$/i, '').trim();
      if (!brand) return;
      var aliases = [];
      function add(value) {
        value = normalizeText(value);
        if (value && aliases.indexOf(value) < 0) aliases.push(value);
      }
      add(brand);
      add(brand.replace(/^Team\s+/i, ''));
      add(brand.replace(/\s+(?:Racing|Adventure|RC)$/i, ''));
      add(brand.replace(/^Team\s+/i, '').replace(/\s+(?:Racing|Adventure|RC)$/i, ''));
      if (aliases.indexOf(q) < 0) return;
      var key = href;
      if (seen[key]) return;
      seen[key] = true;
      results.push({ url: href, title: brand + ' Parts' });
    });
    return results;
  }

  function v625MergeCollections(primary, secondary) {
    var out = [];
    var seen = Object.create(null);
    (primary || []).concat(secondary || []).forEach(function (record) {
      var url = canonicalCollectionUrl(record);
      if (!url || seen[url]) return;
      seen[url] = true;
      out.push(record);
    });
    return out;
  }

  function v618ResolveMenuModels(query) {
    if (numericQuery(query)) return [];
    var q = normalizeText(v618StripScale(query));
    if (!q || q.length < 2) return [];
    return v618VehicleModelRegistry().filter(function (entry) {
      return entry.aliases.indexOf(q) >= 0;
    });
  }

  function v618CollectionRecord(entry) {
    return { url: entry.url, title: entry.label };
  }

  function v618FetchableCollection(entry) {
    if (!entry || !entry.url) return null;
    try {
      var parsed = new URL(entry.url, location.origin);
      if (parsed.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(parsed.pathname)) return null;
      if (parsed.searchParams.has('integy_filter') || parsed.searchParams.has('integy_filters') || parsed.searchParams.has('integy_tag_filter')) return null;
      var handle = parsed.pathname.split('/collections/')[1].replace(/\/$/, '');
      if (!handle || /^(?:all|frontpage|catalog|all-products)$/i.test(handle)) return null;
      return { url: v626LocalizedPath('/collections/' + handle), title: entry.label };
    } catch (error) { return null; }
  }

  function v620ModelRoute(entry) {
    if (!entry || !entry.url) return null;
    try {
      var parsed = new URL(entry.url, location.origin);
      if (parsed.origin !== location.origin) return null;
      var filterValue = parsed.searchParams.get('integy_filter') || parsed.searchParams.get('integy_filters') || parsed.searchParams.get('integy_tag_filter') || '';
      if (/^\/collections\/[^/]+\/?$/.test(parsed.pathname) && filterValue) {
        return { kind: 'filter', entry: entry, parsed: parsed };
      }
      if (/^\/search\/?$/.test(parsed.pathname) && clean(parsed.searchParams.get('q'))) {
        return { kind: 'search', entry: entry, parsed: parsed };
      }
      /* Legacy menu entries can still use collection/tag or other collection URLs.
         They do not have a products.json equivalent that preserves the route filter,
         so V620 parses the destination HTML page-by-page instead of dropping back to
         fuzzy text search. */
      if (/^\/collections\//.test(parsed.pathname)) {
        return { kind: 'html', entry: entry, parsed: parsed };
      }
      return null;
    } catch (error) { return null; }
  }

  function v620Handleize(value) {
    value = clean(value).toLowerCase();
    try { value = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); } catch (error) {}
    return value.replace(/&/g, ' and ').replace(/['\u2019]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function v620IndexCollectionData(index, handle) {
    if (!index || !index.collections) return null;
    if (index.collections[handle]) return index.collections[handle];
    var alias = index.collection_aliases && index.collection_aliases[handle];
    return alias && index.collections[alias] ? index.collections[alias] : null;
  }

  function v620LoadScopedIndex(handle) {
    var urls = window.INTEGY_V454_FILTER_INDEX_URLS || {};
    var url = urls[handle] || '';
    if (!url) return Promise.resolve(null);
    if (!v620RouteIndexCache[url]) {
      v620RouteIndexCache[url] = withTimeout(fetch(url, { credentials: 'same-origin', cache: 'force-cache' }).then(function (response) {
        if (!response.ok) throw new Error('model filter index unavailable');
        return response.json();
      }), 6500, null);
    }
    return v620RouteIndexCache[url];
  }

  function v620FilterTags(parsed) {
    var raw = parsed.searchParams.get('integy_filter') || parsed.searchParams.get('integy_filters') || parsed.searchParams.get('integy_tag_filter') || '';
    return clean(raw).split(/[+\s,]+/).map(v620Handleize).filter(Boolean);
  }

  function v620RecordFromIndexedProduct(product, sku, query, entry) {
    if (!product || !product.url) return null;
    return {
      url: clean(product.url),
      title: clean(product.title),
      sku: clean(product.sku || sku),
      image: clean(product.image),
      price: clean(product.price),
      type: clean(product.display_type || product.type),
      tags: Array.isArray(product.canonical_part_filters) ? product.canonical_part_filters.join(' ') : '',
      description: '',
      variantSkus: [clean(product.sku || sku)].filter(Boolean),
      available: product.available !== false,
      compatibility: [query, entry && entry.label || ''].join(' '),
      _source: 'menu-filter-index-v620'
    };
  }

  function v620FetchFilterRoute(route, query) {
    var parsed = route && route.parsed;
    if (!parsed) return Promise.resolve([]);
    var handle = parsed.pathname.split('/collections/')[1].replace(/\/$/, '');
    var tags = v620FilterTags(parsed);
    if (!handle || !tags.length) return Promise.resolve([]);
    return v620LoadScopedIndex(handle).then(function (index) {
      var collection = v620IndexCollectionData(index, handle);
      if (!index || !collection || !collection.buckets || !index.products) return [];
      var ids = null;
      tags.forEach(function (tag) {
        var canonical = index.aliases && index.aliases[tag] ? index.aliases[tag] : tag;
        var bucket = collection.buckets[canonical] || collection.buckets[tag] || [];
        if (!Array.isArray(bucket) || !bucket.length) { ids = []; return; }
        if (ids == null) ids = bucket.slice();
        else {
          var set = Object.create(null);
          bucket.forEach(function (sku) { set[sku] = true; });
          ids = ids.filter(function (sku) { return !!set[sku]; });
        }
      });
      if (!ids || !ids.length) return [];
      return dedupeProducts(ids.map(function (sku) {
        return v620RecordFromIndexedProduct(index.products[sku], sku, query, route.entry);
      }).filter(Boolean));
    }).catch(function () { return []; });
  }

  function v620HtmlProductRecords(html) {
    if (!html || !window.DOMParser) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var cards = all('.search--section .productgrid--items [data-product-item],.search--section .productgrid--items .productgrid--item,.productgrid--items [data-product-item],.productgrid--items .productgrid--item', doc);
    var records = [];
    var seen = Object.create(null);
    cards.forEach(function (card) {
      var link = one('a[href*="/products/"]', card);
      var url = clean(link && link.getAttribute('href')).split('?')[0];
      if (!/^\/products\/[a-z0-9][a-z0-9-]*$/i.test(url) || seen[url]) return;
      seen[url] = true;
      var sku = firstText(card, ['.integy-product-card-sku','[data-sku]','.productitem--sku','.productitem__sku']).replace(/^SKU:\s*/i, '');
      var title = firstText(card, ['.productitem--title','[data-product-title]','.productitem__title','h2','h3']) || clean(link && link.textContent);
      var price = firstText(card, ['.integy-v410-card-price__current','.productitem--price .money','.productitem--price','[data-price]']);
      var type = firstText(card, ['.integy-v426-card-type','.integy-v158-list-type','.productitem--type','[data-product-type]']).replace(/^Type:\s*/i, '');
      records.push({ url: url, title: title, sku: sku, image: firstImage(card), price: price, type: type, tags: '', description: '', variantSkus: sku ? [sku] : [], available: nativeAvailability(card), _source: 'menu-search-route-v620' });
    });
    return records;
  }

  function v620FetchSearchRoute(route, query) {
    if (!route || !route.parsed) return Promise.resolve([]);
    var base = new URL(route.parsed.href);
    base.searchParams.delete('integy_fast');
    base.searchParams.set('type', 'product');
    base.searchParams.set('options[prefix]', 'last');
    base.searchParams.set('options[unavailable_products]', 'show');
    var cacheKey = base.pathname + '?' + base.searchParams.toString();
    if (v620RouteHtmlCache[cacheKey]) return v620RouteHtmlCache[cacheKey];
    var collected = [];
    function loadPage(page) {
      if (page > 12) return Promise.resolve(collected);
      var url = new URL(base.href);
      url.searchParams.set('page', String(page));
      return withTimeout(fetch(url.pathname + '?' + url.searchParams.toString(), { credentials: 'same-origin', cache: 'force-cache' }).then(function (response) {
        if (!response.ok) throw new Error('menu search route unavailable');
        return response.text();
      }), 6500, '').then(function (html) {
        var pageRecords = v620HtmlProductRecords(html);
        var before = collected.length;
        collected = dedupeProducts(collected.concat(pageRecords));
        if (!pageRecords.length || collected.length === before) return collected;
        return loadPage(page + 1);
      });
    }
    v620RouteHtmlCache[cacheKey] = loadPage(1).then(function (records) {
      records.forEach(function (record) { record.compatibility = [record.compatibility || '', query, route.entry && route.entry.label || ''].join(' '); });
      return records;
    }).catch(function () { return []; });
    return v620RouteHtmlCache[cacheKey];
  }

  function v618AuthoritativeMenuModelSearch(query) {
    var matches = v618ResolveMenuModels(query);
    if (!matches.length) return Promise.resolve(null);
    var tasks = [];
    var seen = Object.create(null);
    matches.forEach(function (entry) {
      var collection = v618FetchableCollection(entry);
      if (collection) {
        var handle = collectionHandle(collection);
        var key = 'collection:' + handle;
        if (handle && !seen[key]) { seen[key] = true; tasks.push(v617FetchCollectionProducts(collection, query)); }
        return;
      }
      var route = v620ModelRoute(entry);
      if (!route) return;
      var routeKey = route.kind + ':' + route.parsed.pathname + '?' + route.parsed.searchParams.toString();
      if (seen[routeKey]) return;
      seen[routeKey] = true;
      tasks.push(route.kind === 'filter' ? v620FetchFilterRoute(route, query) : v620FetchSearchRoute(route, query));
    });
    if (!tasks.length) return Promise.resolve({ records: [], collections: matches.map(v618CollectionRecord), registryOnly: true });
    return Promise.all(tasks).then(function (sets) {
      var records = [];
      sets.forEach(function (set) { records = records.concat(set || []); });
      records = dedupeProducts(records);
      if (!records.length) return { records: [], collections: matches.map(v618CollectionRecord), registryOnly: true };
      return { records: records, collections: matches.map(v618CollectionRecord), registryOnly: false };
    }).catch(function () { return null; });
  }

  function searchAllUrl(query) {
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('options[unavailable_products]', 'show');
    params.set('integy_fast', '1');
    return v626LocalizedPath('/search') + '?' + params.toString();
  }

  function canonicalCollectionUrl(record) {
    var raw = clean(record && record.url);
    if (!raw) return '';
    try {
      var parsed = new URL(raw, location.origin);
      // V574: the current live menu owns /collections/hopups-for-traxxas.
      // Never rewrite it back to the older 7,095-product legacy collection.
      if (parsed.pathname === '/collections/hop-up-parts-for-traxxas' || parsed.pathname === '/collections/parts-for-traxxas') {
        parsed.pathname = '/collections/hopups-for-traxxas';
      }
      return parsed.origin === location.origin
        ? parsed.pathname + parsed.search + parsed.hash
        : parsed.href;
    } catch (error) {
      return raw.replace(/^\/collections\/(?:hop-up-parts-for-traxxas|parts-for-traxxas)(?=[/?#]|$)/, '/collections/hopups-for-traxxas');
    }
  }

  function collectionHandle(record) {
    try {
      return new URL(canonicalCollectionUrl(record), location.origin).pathname.split('/collections/')[1].split(/[/?#]/)[0] || '';
    } catch (error) { return ''; }
  }

  function titleCase(value) {
    return String(value || '').split(' ').map(function (word) {
      if (/^(?:rc|rtr|vxl|blx|lmt|trx|xrt|hpi|esc)$/i.test(word)) return word.toUpperCase();
      if (/^\d+x\d+$/i.test(word)) return word.toUpperCase();
      return word ? word.charAt(0).toUpperCase() + word.slice(1) : '';
    }).join(' ');
  }

  function collectionDisplayTitle(record) {
    var title = clean(record && record.title)
      .replace(/\s*[|—–]\s*Integy Official Shop.*$/i, '')
      .replace(/\s*Browse compatible products.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (title && title.length <= 74) return title;
    var handle = collectionHandle(record);
    if (!handle) return title.slice(0, 74) || 'Browse collection';
    var label = handle
      .replace(/^(?:hop-up-parts-for|hopups-for|parts-for|upgrades-for)-/, '')
      .replace(/-(\d+)-(\d+)(?=-|$)/g, ' $1/$2 ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    label = titleCase(label);
    if (!/parts|accessories|vehicles|tools|tires|wheels/i.test(label)) label += ' Parts';
    return label.slice(0, 74);
  }

  function collectionScore(record, query) {
    var queryText = normalizeText(query);
    var title = normalizeText(collectionDisplayTitle(record));
    var handle = normalizeText(collectionHandle(record).replace(/-/g, ' '));
    var score = 0;
    if (title === queryText) score += 5000;
    if (title.indexOf(queryText) === 0) score += 3000;
    if (handle.indexOf(queryText) >= 0) score += 1800;
    var tokens = queryText.split(' ').filter(function (token) { return token.length > 1; });
    var matched = 0;
    tokens.forEach(function (token) {
      if (title.indexOf(token) >= 0 || handle.indexOf(token) >= 0) matched += 1;
    });
    score += matched * 500;
    score -= Math.max(0, title.length - 45) * 2;
    return score;
  }

  function rankCollections(records, query) {
    var source = records || [];
    if (api && typeof api.rankCollections === 'function') {
      try { source = api.rankCollections(source, query); }
      catch (error) {}
    }
    source = source.map(function (record) {
      var canonicalUrl = canonicalCollectionUrl(record);
      if (!canonicalUrl || canonicalUrl === clean(record && record.url)) return record;
      var normalized = {};
      Object.keys(record || {}).forEach(function (key) { normalized[key] = record[key]; });
      normalized.url = canonicalUrl;
      return normalized;
    });
    var seen = Object.create(null);
    return source.filter(function (record) {
      var url = canonicalCollectionUrl(record);
      if (!url || seen[url]) return false;
      seen[url] = true;
      return true;
    }).map(function (record, index) {
      return { record: record, score: collectionScore(record, query), index: index };
    }).filter(function (entry) { return entry.score > 0; })
      .sort(function (left, right) { return right.score - left.score || left.index - right.index; })
      .map(function (entry) { return entry.record; });
  }

  function storefrontType(record) {
    return clean(record && record.type);
  }

  function suggestionMarkup(record, index) {
    var price = priceText(record);
    var stock = record && record.available === true
      ? '<span class="integy-v520-search-stock is-in-stock">In stock</span>'
      : record && record.available === false
        ? '<span class="integy-v520-search-stock is-sold-out">Sold out</span>'
        : '';
    var productUrl = safeProductUrl(record);
    return '<a class="integy-v520-search-product" href="' + escapeHtml(productUrl) + '" role="option" data-integy-v605-predictive-product="true" data-integy-v529-product-url="' + escapeHtml(productUrl) + '" data-sku="' + escapeHtml(record && record.sku || '') + '">' +
      '<span class="integy-v520-search-product__media"><img src="' + escapeHtml(imageSource(record)) + '" alt="" width="160" height="160" loading="' + (index < 4 ? 'eager' : 'lazy') + '" decoding="async"></span>' +
      '<span class="integy-v520-search-product__copy">' +
        '<strong>' + escapeHtml(record && record.title || '') + '</strong>' +
        '<span class="integy-v520-search-product__sku">' + (record && record.sku ? 'SKU: ' + escapeHtml(record.sku) : '') + '</span>' +
        '<span class="integy-v520-search-product__type">' + escapeHtml(storefrontType(record)) + '</span>' +
        '<span class="integy-v520-search-product__bottom">' +
          '<b data-integy-v719-predictive-price>Checking price...</b>' + '<span class="integy-v520-search-stock" data-integy-v719-predictive-stock>Checking stock...</span>' +
        '</span>' +
      '</span></a>';
  }

  function collectionMarkup(record) {
    var collectionUrl = canonicalCollectionUrl(record) || '#';
    if (collectionUrl !== '#' && collectionUrl.charAt(0) === '/') collectionUrl = v626LocalizedPath(collectionUrl);
    return '<a class="integy-v520-search-collection" href="' + escapeHtml(collectionUrl) + '">' +
      '<span class="integy-v520-search-collection__copy"><strong>' + escapeHtml(collectionDisplayTitle(record)) + '</strong><small>Collection</small></span>' +
      '<span class="integy-v520-search-collection__arrow" aria-hidden="true">›</span></a>';
  }

  /* INTEGY V547 — owned search-result cards keep the collection-card
     commerce contract with compare-at price + Save %, live availability, and
     direct Add to Cart for single-variant products. Product JSON hydration is
     viewport-lazy, concurrency-limited, and cached so a 72-result search does
     not fire 72 requests at once. */
  var v529ProductCache = Object.create(null);
  var v529ProductQueue = [];
  var v529ProductActive = 0;
  var v529PriceObserver = null;

  function v529Money(cents) {
    cents = Number(cents);
    return Number.isFinite(cents) && cents >= 0 ? v626MoneyFromCents(cents) : '';
  }

  function v529RecordPriceCents(record) {
    if (record && Number.isFinite(Number(record.price_cents))) return Math.max(0, Math.round(Number(record.price_cents)));
    var text = priceText(record).replace(/[^0-9.]/g, '');
    var dollars = Number(text || 0);
    return Number.isFinite(dollars) ? Math.max(0, Math.round(dollars * 100)) : 0;
  }

  function v529ProductEndpoint(value) {
    try {
      var url = new URL(value || '', location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? v626LocalizedPath('/products/' + match[1] + '.js') : '';
    } catch (error) { return ''; }
  }

  function v529FinishProductJob(key, result) {
    var entry = v529ProductCache[key];
    if (!entry) return;
    entry.state = 'done';
    entry.result = result || null;
    var callbacks = entry.callbacks || [];
    entry.callbacks = [];
    callbacks.forEach(function (callback) {
      try { callback(entry.result); } catch (error) {}
    });
  }

  /* V719: a stalled product response must not occupy a queue slot forever.
     Timeout includes JSON parsing; abort also frees the network request. */
  function v719FetchProductJson(endpoint) {
    return new Promise(function (resolve, reject) {
      var controller = window.AbortController ? new AbortController() : null;
      var settled = false;
      function finish(error, product) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (error) reject(error); else resolve(product);
      }
      var timer = window.setTimeout(function () {
        finish(new Error('Product verification timed out'));
        if (controller) controller.abort();
      }, 12000);
      Promise.resolve().then(function () {
        return fetch(endpoint, {
          credentials: 'same-origin', cache: 'no-cache',
          headers: { 'Accept': 'application/json' },
          signal: controller ? controller.signal : undefined
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Product verification unavailable');
        return response.json();
      }).then(function (product) { finish(null, product); }, function (error) { finish(error); });
    });
  }

  function v529PumpProductQueue() {
    while (v529ProductActive < 4 && v529ProductQueue.length) {
      (function (job) {
        v529ProductActive += 1;
        v719FetchProductJson(job.endpoint)
          .then(function (product) {
            var variants = product && Array.isArray(product.variants) ? product.variants : [];
            var sku = normalizeSku(job.sku || '');
            var variant = null;
            if (sku) {
              variant = variants.find(function (candidate) { return normalizeSku(candidate && candidate.sku || '') === sku; }) || null;
            }
            if (!sku) variant = variants.find(function (candidate) { return candidate && candidate.available; }) || variants[0] || null;
            var anyAvailable = variants.some(function (candidate) { return !!(candidate && candidate.available); });
            v529FinishProductJob(job.key, variant ? {
              price: Number(variant.price || 0),
              compare: Number(variant.compare_at_price || 0),
              available: sku ? !!variant.available : anyAvailable,
              title: product && typeof product.title === 'string' ? product.title : '',
              type: product && typeof product.type === 'string' ? product.type : '',
              variantId: variant && variant.id ? String(variant.id) : '',
              variantCount: variants.length,
              image: clean(product && (product.featured_image || (product.images && product.images[0]) || ''))
            } : null);
          })
          .catch(function () { v529FinishProductJob(job.key, null); })
          .then(function () {
            v529ProductActive = Math.max(0, v529ProductActive - 1);
            v529PumpProductQueue();
          });
      })(v529ProductQueue.shift());
    }
  }

  function v529RequestProduct(card, callback) {
    var endpoint = v529ProductEndpoint(card && card.getAttribute('data-integy-v529-product-url'));
    var sku = card && (card.getAttribute('data-sku') || '');
    if (!endpoint) { callback(null); return; }
    var key = endpoint + '|' + normalizeSku(sku);
    var cached = v529ProductCache[key];
    if (cached && cached.state === 'done') { callback(cached.result); return; }
    if (cached && cached.state === 'pending') { cached.callbacks.push(callback); return; }
    v529ProductCache[key] = { state: 'pending', callbacks: [callback], result: null };
    v529ProductQueue.push({ key: key, endpoint: endpoint, sku: sku });
    v529PumpProductQueue();
  }

  function v529ApplySearchCommerce(card, detail) {
    if (!card || !card.isConnected) return;
    card.setAttribute('data-integy-v529-commerce-state', 'done');
    if (!detail) {
      /* V724: failed verification must not leave cached price/stock claims. */
      var failedPrice = one('[data-integy-v529-current-price]', card);
      var failedStock = one('.integy-v456-search-stock', card);
      if (failedPrice) failedPrice.textContent = 'See product price';
      if (failedStock) { failedStock.textContent = 'Check availability'; failedStock.className = 'integy-v456-search-stock'; }
      card.setAttribute('data-product-available', '');
      all('[data-integy-v529-compare-price], [data-integy-v529-sale-badge]', card).forEach(function (node) { node.hidden = true; node.textContent = ''; });
      var failedActions = one('.integy-v547-direct-actions', card);
      if (failedActions) {
        var failedUrl = card.getAttribute('data-integy-v529-product-url') || '#';
        failedActions.innerHTML = '<a class="productitem--action-trigger button-primary integy-v547-choose-options" href="' + escapeHtml(failedUrl) + '">View Details</a>';
      }
      return;
    }
    /* V724: refresh from Shopify, never substitute a hardcoded title. */
    var liveTitle = one('.productitem--title a', card);
    if (liveTitle && detail.title) liveTitle.textContent = detail.title;
    var imageLink = one('.integy-v426-search-card__image', card);
    if (imageLink && detail.title) imageLink.setAttribute('aria-label', detail.title);
    var liveType = one('.integy-v426-search-card__type', card);
    if (liveType && typeof detail.type === 'string') {
      liveType.textContent = detail.type;
      liveType.hidden = !detail.type.trim();
    }
    var liveImage = clean(detail.image || '');
    var imageNode = one('.integy-v426-search-card__media img', card);
    if (imageNode && liveImage) {
      imageNode.setAttribute('src', liveImage);
      imageNode.removeAttribute('srcset');
      imageNode.setAttribute('data-integy-v605-image-source', 'shopify-product-json');
    }
    var current = Number(detail.price);
    var compare = Number(detail.compare || 0);
    var currentNode = one('[data-integy-v529-current-price]', card);
    var compareNode = one('[data-integy-v529-compare-price]', card);
    var saleBadge = one('[data-integy-v529-sale-badge]', card);
    if (currentNode) currentNode.textContent = Number.isFinite(current) && current >= 0 ? v529Money(current) : 'See product price';
    if (compareNode) {
      if (compare > current && current > 0) {
        compareNode.textContent = v529Money(compare);
        compareNode.hidden = false;
      } else {
        compareNode.hidden = true;
        compareNode.textContent = '';
      }
    }
    if (saleBadge) {
      if (compare > current && current > 0) {
        var percent = Math.max(1, Math.round(((compare - current) * 100) / compare));
        saleBadge.textContent = 'Save ' + percent + '%';
        saleBadge.hidden = false;
      } else {
        saleBadge.hidden = true;
        saleBadge.textContent = '';
      }
    }
    card.setAttribute('data-product-available', detail.available ? 'true' : 'false');
    var stock = one('.integy-v456-search-stock', card);
    if (!stock) {
      var body = one('.integy-v426-search-card__body', card);
      if (body) { body.insertAdjacentHTML('beforeend', '<div class="integy-v456-search-stock"></div>'); stock = one('.integy-v456-search-stock', card); }
    }
    if (stock) { stock.className = 'integy-v456-search-stock ' + (detail.available ? 'is-in-stock' : 'is-sold-out'); stock.textContent = detail.available ? 'In stock' : 'Sold out'; }
    var actions = one('.integy-v547-direct-actions', card);
    if (actions) {
      var productUrl = card.getAttribute('data-integy-v529-product-url') || '#';
      if (!detail.available) actions.innerHTML = '<button class="productitem--action-trigger button-primary integy-v547-direct-atc is-sold-out" type="button" disabled>Sold Out</button>';
      else if (Number(detail.variantCount || 0) === 1 && detail.variantId) actions.innerHTML = '<button class="productitem--action-trigger button-primary integy-v547-direct-atc" type="button" data-integy-v547-atc data-variant-id="' + escapeHtml(detail.variantId) + '" data-product-url="' + escapeHtml(productUrl) + '">Add to Cart</button>';
      else actions.innerHTML = '<a class="productitem--action-trigger button-primary integy-v547-choose-options" href="' + escapeHtml(productUrl) + '">Choose Options</a>';
    }
  }

  function v605HydratePredictiveImages(scope) {
    all('[data-integy-v605-predictive-product="true"]', scope || document).forEach(function (item) {
      if (item.getAttribute('data-integy-v605-image-state')) return;
      item.setAttribute('data-integy-v605-image-state', 'loading');
      v529RequestProduct(item, function (detail) {
        if (!item || !item.isConnected) return;
        item.setAttribute('data-integy-v605-image-state', 'done');
        /* V719: the same verified detail now owns price and stock as well as media.
           Never advertise cached catalog dollars as a live predictive price. */
        var titleNode = one('.integy-v520-search-product__copy > strong', item);
        if (titleNode && detail && detail.title) titleNode.textContent = detail.title;
        var typeNode = one('.integy-v520-search-product__type', item);
        if (typeNode && detail && typeof detail.type === 'string') {
          typeNode.textContent = detail.type;
          typeNode.hidden = !detail.type.trim();
        }
        var priceNode = one('[data-integy-v719-predictive-price]', item);
        var stockNode = one('[data-integy-v719-predictive-stock]', item);
        if (priceNode) priceNode.textContent = detail && Number.isFinite(Number(detail.price))
          ? v529Money(Number(detail.price)) : 'See product price';
        if (stockNode) {
          stockNode.textContent = detail ? (detail.available ? 'In stock' : 'Sold out') : 'Check availability';
          stockNode.className = 'integy-v520-search-stock' + (detail ? (detail.available ? ' is-in-stock' : ' is-sold-out') : '');
        }
        var img = one('.integy-v520-search-product__media img', item);
        var liveImage = clean(detail && detail.image || '');
        if (img && liveImage) {
          img.setAttribute('src', liveImage);
          img.removeAttribute('srcset');
          img.setAttribute('data-integy-v605-image-source', 'shopify-product-json');
        }
      });
    });
  }

  function v529HydrateSearchCard(card) {
    if (!card || card.getAttribute('data-integy-v529-commerce-state') === 'loading' || card.getAttribute('data-integy-v529-commerce-state') === 'done') return;
    card.setAttribute('data-integy-v529-commerce-state', 'loading');
    v529RequestProduct(card, function (detail) { v529ApplySearchCommerce(card, detail); });
  }

  function v529ObserveSearchCards(scope) {
    var cards = all('[data-integy-v529-search-card="true"]', scope || document).filter(function (card) {
      return card.getAttribute('data-integy-v529-commerce-state') !== 'loading' && card.getAttribute('data-integy-v529-commerce-state') !== 'done';
    });
    if (!cards.length) return;
    if (!window.IntersectionObserver) { cards.forEach(v529HydrateSearchCard); return; }
    if (!v529PriceObserver) {
      v529PriceObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          v529PriceObserver.unobserve(entry.target);
          v529HydrateSearchCard(entry.target);
        });
      }, { rootMargin: '1000px 0px' });
    }
    cards.forEach(function (card) { v529PriceObserver.observe(card); });
  }

  function exactCardMarkup(record, index) {
    var price = priceText(record);
    var url = safeProductUrl(record);
    var sku = clean(record && record.sku || '');
    var priceCents = v529RecordPriceCents(record);
    var available = record && record.available === true;
    var soldOut = record && record.available === false;
    var liveVerified = !!(record && record._integy_v605_live_verified);
    if (!liveVerified) price = 'Checking price…';
    var liveVariantId = clean(record && record._integy_v605_variant_id || '');
    var liveVariantCount = Number(record && record._integy_v605_variant_count || 0);
    var directAction = '<div class="integy-v529-search-actions integy-v547-direct-actions" data-product-actions><button class="productitem--action-trigger button-primary integy-v547-direct-atc is-pending" type="button" data-integy-v547-atc-pending disabled>Checking…</button></div>';
    if (liveVerified) {
      if (!available) directAction = '<div class="integy-v529-search-actions integy-v547-direct-actions" data-product-actions><button class="productitem--action-trigger button-primary integy-v547-direct-atc is-sold-out" type="button" disabled>Sold Out</button></div>';
      else if (liveVariantCount === 1 && liveVariantId) directAction = '<div class="integy-v529-search-actions integy-v547-direct-actions" data-product-actions><button class="productitem--action-trigger button-primary integy-v547-direct-atc" type="button" data-integy-v547-atc data-variant-id="' + escapeHtml(liveVariantId) + '" data-product-url="' + escapeHtml(url) + '">Add to Cart</button></div>';
      else directAction = '<div class="integy-v529-search-actions integy-v547-direct-actions" data-product-actions><a class="productitem--action-trigger button-primary integy-v547-choose-options" href="' + escapeHtml(url) + '">Choose Options</a></div>';
    }
    return '<article class="integy-v426-search-card integy-v431-search-card integy-v520-search-card integy-v529-search-card" data-product-item data-integy-v460-dynamic-card="search" data-integy-v529-search-card="true" data-integy-v529-product-url="' + escapeHtml(url) + '" data-integy-v529-price-cents="' + priceCents + '" data-integy-v426-product-url="' + escapeHtml(url) + '" data-product-available="' + (liveVerified ? (available ? 'true' : soldOut ? 'false' : '') : '') + '" data-sku="' + escapeHtml(sku) + '"' + (liveVerified ? ' data-integy-v529-commerce-state="done"' : '') + '>' +
      '<a class="integy-v426-search-card__image" href="' + escapeHtml(url) + '" aria-label="' + escapeHtml(record && record.title || sku || 'View product') + '"><span class="integy-v426-search-card__media"><img src="' + escapeHtml(imageSource(record)) + '" alt="" width="640" height="640" loading="' + (index < 6 ? 'eager' : 'lazy') + '" decoding="async"></span><span class="integy-v529-search-sale-badge" data-integy-v529-sale-badge hidden></span></a>' +
      '<div class="integy-v426-search-card__body" data-product-item-content><h2 class="productitem--title"><a href="' + escapeHtml(url) + '">' + escapeHtml(record && record.title || '') + '</a></h2>' +
      (sku ? '<div class="integy-v426-search-card__sku">SKU: ' + escapeHtml(sku) + '</div>' : '') +
      '<div class="integy-v426-search-card__type"' + (storefrontType(record) ? '' : ' hidden') + '>' + escapeHtml(storefrontType(record)) + '</div>' +
      (price ? '<div class="integy-v426-search-card__price integy-v529-search-price"><span class="money integy-v529-search-price__current" data-integy-v529-current-price>' + escapeHtml(price) + '</span><s class="money integy-v529-search-price__compare" data-integy-v529-compare-price hidden></s></div>' : '') +
      (!liveVerified ? '<div class="integy-v456-search-stock">Checking availability…</div>' : available ? '<div class="integy-v456-search-stock is-in-stock">In stock</div>' : soldOut ? '<div class="integy-v456-search-stock is-sold-out">Sold out</div>' : '<div class="integy-v456-search-stock">Check availability</div>') +
      directAction + '</div></article>';
  }

  function getPanel() {
    var panel = document.getElementById(panelId);
    if (!panel) {
      panel = document.createElement('div');
      panel.id = panelId;
      panel.className = 'integy-v520-search-panel';
      panel.setAttribute('role', 'listbox');
      panel.setAttribute('aria-label', 'Product search suggestions');
      panel.hidden = true;
      document.body.appendChild(panel);
    }
    return panel;
  }

  function mountPanel(input) {
    var panel = getPanel();
    var takeover = input && input.closest ? input.closest('.integy-v501-body-search,.live-search--takeover') : null;
    var host = takeover || document.body;
    if (panel.parentNode !== host) host.appendChild(panel);
    panel.classList.toggle('integy-v520-search-panel--takeover', !!takeover);
    panel.removeAttribute('aria-hidden');
    try { panel.inert = false; } catch (error) {}
    return panel;
  }

  function positionPanel(input) {
    var panel = mountPanel(input);
    if (!input || !input.isConnected || panel.hidden) return;
    var takeover = input.closest ? input.closest('.integy-v501-body-search,.live-search--takeover') : null;
    /* INTEGY V532 — the predictive panel is a normal flex child of the mobile
       takeover. Do not run a second fixed visualViewport positioning system inside
       an already viewport-aligned dialog. */
    if (takeover) {
      ['--integy-v520-panel-left','--integy-v520-panel-top','--integy-v520-panel-width','--integy-v520-panel-max-height'].forEach(function (name) {
        panel.style.removeProperty(name);
      });
      return;
    }
    var form = input.closest('form') || input;
    var formRect = form.getBoundingClientRect();
    var inputRect = input.getBoundingClientRect();
    var viewport = window.visualViewport;
    var viewportWidth = viewport ? viewport.width : (document.documentElement.clientWidth || window.innerWidth);
    var viewportHeight = viewport ? viewport.height : window.innerHeight;
    var offsetLeft = viewport ? viewport.offsetLeft : 0;
    var offsetTop = viewport ? viewport.offsetTop : 0;
    var compact = viewportWidth < 760;
    var gutter = compact ? 8 : 12;
    var width = compact
      ? viewportWidth - gutter * 2
      : Math.min(Math.max(formRect.width, 620), 780, viewportWidth - gutter * 2);
    var left = compact
      ? offsetLeft + gutter
      : Math.max(offsetLeft + gutter, Math.min(formRect.left, offsetLeft + viewportWidth - gutter - width));
    var top = inputRect.bottom + 6;
    /* V719: a 160px minimum can extend behind a landscape keyboard. */
    var maxHeight = Math.max(0, offsetTop + viewportHeight - top - gutter);
    panel.style.setProperty('--integy-v520-panel-left', Math.round(left) + 'px');
    panel.style.setProperty('--integy-v520-panel-top', Math.round(top) + 'px');
    panel.style.setProperty('--integy-v520-panel-width', Math.round(width) + 'px');
    panel.style.setProperty('--integy-v520-panel-max-height', Math.round(maxHeight) + 'px');
  }

  function closePanel() {
    requestSerial += 1;
    window.clearTimeout(inputTimer);
    window.clearTimeout(predictiveTimeout);
    if (predictiveController) { try { predictiveController.abort(); } catch (error) {} }
    var panel = document.getElementById(panelId);
    if (panel) {
      panel.hidden = true;
      panel.innerHTML = '';
      panel.removeAttribute('data-query');
    }
    if (activeInput && activeInput.isConnected) activeInput.setAttribute('aria-expanded', 'false');
    activeInput = null;
    root.classList.remove('integy-v520-search-open');
  }

  function openLoading(input, query) {
    activeInput = input;
    var panel = mountPanel(input);
    panel.hidden = false;
    panel.setAttribute('data-query', query);
    panel.innerHTML = '<div class="integy-v520-search-loading" role="status">Searching products…</div>';
    input.setAttribute('aria-expanded', 'true');
    root.classList.add('integy-v520-search-open');
    positionPanel(input);
  }

  function renderPanel(input, query, exactRecords, productRecords, collectionRecords) {
    if (!input || !input.isConnected || activeInput !== input || clean(input.value) !== query) return;
    var panel = getPanel();
    var exact = dedupeProducts(exactRecords || []);
    var exactSkus = Object.create(null);
    exact.forEach(function (record) { exactSkus[normalizeSku(record.sku)] = true; });
    var related = rankProducts(productRecords || [], query).filter(function (record) {
      return !exactSkus[normalizeSku(record.sku)];
    });
    var numeric = numericQuery(query);
    exact = exact.slice(0, 8);
    related = related.slice(0, numeric && numeric.length >= 5 ? 3 : 6);
    var collections = numeric ? [] : rankCollections(collectionRecords || [], query).slice(0, 3);
    var html = '';
    if (collections.length) {
      html += '<section class="integy-v520-search-section integy-v520-search-section--collections"><h3>Shop by vehicle or category</h3><div class="integy-v520-search-collections">' + collections.map(collectionMarkup).join('') + '</div></section>';
    }
    if (exact.length) {
      html += '<section class="integy-v520-search-section"><h3>Exact SKU ' + (exact.length === 1 ? 'match' : 'matches') + '</h3><div class="integy-v520-search-products">' + exact.map(suggestionMarkup).join('') + '</div></section>';
    }
    if (related.length) {
      html += '<section class="integy-v520-search-section"><h3>' + (exact.length ? 'Related products' : 'Quick product matches') + '</h3><div class="integy-v520-search-products">' + related.map(suggestionMarkup).join('') + '</div></section>';
    }
    if (exact.length || related.length || collections.length) {
      html += '<a class="integy-v520-search-all" href="' + escapeHtml(searchAllUrl(query)) + '">View all products for “' + escapeHtml(query) + '”</a>';
    } else {
      html += '<div class="integy-v520-search-empty">No quick matches. <a href="' + escapeHtml(searchAllUrl(query)) + '">Search all products</a></div>';
    }
    panel.innerHTML = html;
    v605HydratePredictiveImages(panel);
    panel.hidden = false;
    panel.setAttribute('data-query', query);
    positionPanel(input);
  }

  function renderPanelFailure(input, query) {
    if (!input || !input.isConnected || activeInput !== input || clean(input.value) !== query) return;
    var panel = getPanel();
    panel.hidden = false;
    panel.innerHTML = '<div class="integy-v520-search-error" role="status"><strong>Quick search could not load.</strong><span>Check your connection, then try again.</span><button type="button" data-integy-v520-search-retry>Retry</button><a href="' + escapeHtml(searchAllUrl(query)) + '">Open full search</a></div>';
    panel.setAttribute('data-query', query);
    positionPanel(input);
  }

  function runQuickSearch(input) {
    var query = clean(input.value);
    if (query.length < 2 || (/^\d+$/.test(query) && query.length < 3)) {
      closePanel();
      return;
    }
    var serial = ++requestSerial;
    openLoading(input, query);
    var numeric = numericQuery(query);
    if (numeric) {
      Promise.all([
        numeric.length >= 4 ? exactNumericSearch(numeric) : Promise.resolve([]),
        numericPrefixSearch(numeric),
        withTimeout(v712DeltaSearch(numeric), 2200, [])
      ]).then(function (sets) {
        if (serial !== requestSerial || activeInput !== input) return;
        var v712Delta = sets[2] || [];
        var v712Exact = v712Delta.filter(function (record) { return exactSkuQuery(record, query) || recordDigitGroups(record).indexOf(numeric) >= 0; });
        renderPanel(input, query, dedupeProducts(v712Exact.concat(sets[0] || [])), dedupeProducts(v712Delta.concat(sets[1] || [])), []);
      }).catch(function () {
        if (serial === requestSerial) renderPanelFailure(input, query);
      });
      return;
    }

    Promise.all([localSearch(query), fetchPredictive(query), exactSkuSearch(query)]).then(function (sets) {
      if (serial !== requestSerial || activeInput !== input) return;
      var predictive = sets[1] || { products: [], collections: [] };
      var collections = v625MergeCollections(v625BrandCollections(query), predictive.collections || []);
      renderPanel(input, query, sets[2] || [], (sets[0] || []).concat(predictive.products || []), collections);
    }).catch(function () {
      if (serial === requestSerial) renderPanelFailure(input, query);
    });
  }

  function scheduleQuickSearch(input) {
    window.clearTimeout(inputTimer);
    var query = clean(input.value);
    if (query.length < 2 || (/^\d+$/.test(query) && query.length < 3)) return closePanel();
    openLoading(input, query);
    inputTimer = window.setTimeout(function () { runQuickSearch(input); }, numericQuery(query) ? 45 : 130);
  }

  function normalizeSearchForm(form) {
    if (!form || String(form.getAttribute('action') || '').indexOf('/search') < 0) return;
    form.setAttribute('action', v626LocalizedPath('/search'));
    [['type', 'product'], ['integy_fast', '1'], ['options[prefix]', 'last'], ['options[unavailable_products]', 'show']].forEach(function (pair) {
      var input = Array.prototype.find.call(form.elements || [], function (element) { return element.name === pair[0]; });
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = pair[0];
        form.appendChild(input);
      }
      input.value = pair[1];
    });
  }

  function nativeSearchNodes() {
    return all('.search--section .productgrid--sidebar,.search--section .productgrid--items,.search--section .productgrid--no-results,.search--section .productgrid--footer,.search--section .productgrid--wrapper > .productgrid--filters,.search--section .productgrid--wrapper > .productgrid--utils-sticky-intersection,.search--section .productgrid--wrapper > .productgrid--utils-container,#integy-v426-search-results');
  }

  function showSearchPagination() {
    all('.search--section .pagination--container,.search--section .pagination').forEach(function (node) {
      node.hidden = false;
      node.removeAttribute('aria-hidden');
    });
  }

  function firstText(scope, selectors) {
    for (var index = 0; index < selectors.length; index += 1) {
      var node = one(selectors[index], scope);
      var value = clean(node && (node.getAttribute('content') || node.textContent));
      if (value) return value;
    }
    return '';
  }

  function firstImage(scope) {
    var image = one('img', scope);
    if (!image) return '';
    var values = [
      image.currentSrc,
      image.getAttribute('src'),
      image.getAttribute('data-src'),
      image.getAttribute('data-rimg'),
      image.getAttribute('data-srcset'),
      image.getAttribute('srcset')
    ];
    for (var index = 0; index < values.length; index += 1) {
      var value = clean(values[index]);
      if (!value) continue;
      if (value.indexOf(',') >= 0) value = clean(value.split(',').pop()).split(' ')[0];
      if (/^(?:https?:)?\/\//i.test(value) || value.charAt(0) === '/') return value;
    }
    return '';
  }

  function nativeAvailability(scope) {
    var text = normalizeText(scope && scope.textContent);
    if (/\b(?:sold out|out of stock|unavailable)\b/.test(text)) return false;
    if (/\bin stock\b/.test(text)) return true;
    var disabled = one('[disabled],[aria-disabled="true"],.productitem--action-atc.disabled', scope);
    if (disabled) return false;
    return null;
  }

  function nativeSearchRecords() {
    var cards = all('.search--section .productgrid--items [data-product-item],.search--section .productgrid--items .productgrid--item');
    var records = [];
    var seen = Object.create(null);
    cards.forEach(function (card) {
      var link = one('a[href*="/products/"]', card);
      var url = clean(link && link.getAttribute('href')).split('?')[0];
      if (!/^\/products\/[a-z0-9][a-z0-9-]*$/i.test(url) || seen[url]) return;
      seen[url] = true;
      var sku = firstText(card, ['.integy-product-card-sku','[data-sku]','.productitem--sku','.productitem__sku']).replace(/^SKU:\s*/i, '');
      var title = firstText(card, ['.productitem--title','[data-product-title]','.productitem__title','h2','h3']);
      if (!title) title = clean(link && link.textContent);
      var price = firstText(card, ['.integy-v410-card-price__current','.productitem--price .money','.productitem--price','[data-price]']);
      var type = firstText(card, ['.integy-v426-card-type','.integy-v158-list-type','.productitem--type','[data-product-type]']).replace(/^Type:\s*/i, '');
      records.push({
        url: url,
        title: title,
        sku: sku,
        image: firstImage(card),
        price: price,
        type: type,
        tags: '',
        description: '',
        variantSkus: sku ? [sku] : [],
        available: nativeAvailability(card),
        _source: 'native-shopify'
      });
    });
    return records;
  }

  function exactNativeSkuRecords(records, query) {
    var normalized = normalizeSku(query);
    if (!normalized) return [];
    var exact = (records || []).filter(function (record) {
      return [record && record.sku].concat(record && record.variantSkus || []).some(function (sku) {
        return normalizeSku(sku) === normalized;
      });
    });
    if (exact.length) return exact;
    return (records || []).filter(function (record) {
      return [record && record.sku].concat(record && record.variantSkus || []).some(function (sku) {
        return normalizeSku(sku).indexOf(normalized) === 0;
      });
    });
  }

  function exactNativeNumericRecords(records, query, prefixOnly) {
    return (records || []).filter(function (record) {
      return recordDigitGroups(record).some(function (group) {
        return prefixOnly ? group.indexOf(query) === 0 : group === query;
      });
    });
  }

  function hideNativeSearchResults() {
    nativeSearchNodes().forEach(function (node) {
      if (node.id === resultsId) return;
      if (node.id === 'integy-v426-search-results') {
        node.innerHTML = '';
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
        node.style.setProperty('display', 'none', 'important');
        return;
      }
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
      node.style.setProperty('display', 'none', 'important');
    });
    showSearchPagination();
  }

  function showNativeSearchResults() {
    nativeSearchNodes().forEach(function (node) {
      if (node.id === 'integy-v426-search-results') {
        node.innerHTML = '';
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
        node.style.setProperty('display', 'none', 'important');
        return;
      }
      node.style.removeProperty('display');
      node.hidden = false;
      node.removeAttribute('aria-hidden');
    });
    showSearchPagination();
  }

  function exactResultsContainer() {
    var container = document.getElementById(resultsId);
    if (container) return container;
    var wrapper = one('.search--section .productgrid--wrapper') || one('main');
    if (!wrapper) return null;
    container = document.createElement('section');
    container.id = resultsId;
    container.className = 'integy-v520-search-results';
    var masthead = one('.productgrid--masthead', wrapper);
    wrapper.insertBefore(container, masthead ? masthead.nextSibling : wrapper.firstChild);
    return container;
  }

  function updateSearchPageLabel(count, query, mode, total) {
    var label;
    if (mode === 'exact') label = count + ' exact product' + (count === 1 ? '' : 's') + ' for “' + query + '”';
    else if (mode === 'prefix') label = (total > count ? 'Showing ' + count + ' of ' + total : count) + ' products with SKU number beginning “' + query + '”';
    else if (mode === 'model') label = (total > count ? 'Showing ' + count + ' of ' + total : count) + ' compatible products for “' + query + '”';
    else label = (total > count ? 'Showing ' + count + ' of ' + total : count) + ' products matching “' + query + '”';
    var crumbs = all('.breadcrumbs-container > span');
    if (crumbs.length) crumbs[crumbs.length - 1].textContent = label;
    var suffix = (document.title.match(/(\s+[–—|]\s+.+)$/) || [])[1] || '';
    document.title = label + suffix;
  }

  function pageLimit() {
    return window.matchMedia('(max-width: 740px)').matches ? 36 : window.matchMedia('(max-width: 1100px)').matches ? 48 : 72;
  }

  function paintOwnedSearchPage(append) {
    var state = ownedPageState;
    var container = exactResultsContainer();
    if (!state || !container) return;
    hideNativeSearchResults();
    if (state.mode === 'empty') {
      container.hidden = false;
      container.setAttribute('data-integy-v520-search-mode', 'empty');
      container.innerHTML = '<div class="integy-v720-search-empty" role="status"><h1>No matching products</h1><p>No products matched “' + escapeHtml(state.query) + '”. Try a shorter SKU, model name, or part type.</p></div>';
      updateSearchPageLabel(0, state.query, 'broad', 0);
      return;
    }
    var shown = state.records.slice(0, state.visible);
    var heading;
    if (state.mode === 'exact') heading = shown.length + ' exact product' + (shown.length === 1 ? '' : 's') + ' matching “' + escapeHtml(state.query) + '”';
    else if (state.mode === 'prefix') heading = (state.records.length > shown.length ? 'Showing ' + shown.length + ' of ' + state.records.length : state.records.length) + ' products with SKU number beginning “' + escapeHtml(state.query) + '”';
    else if (state.mode === 'model') heading = (state.records.length > shown.length ? 'Showing ' + shown.length + ' of ' + state.records.length : state.records.length) + ' compatible products for “' + escapeHtml(state.query) + '”';
    else heading = (state.records.length > shown.length ? 'Showing ' + shown.length + ' of ' + state.records.length : state.records.length) + ' products matching “' + escapeHtml(state.query) + '”';
    var collectionHtml = state.collections.length ? '<section class="integy-v520-page-collections"><h2>Shop by vehicle or category</h2><div>' + state.collections.map(collectionMarkup).join('') + '</div></section>' : '';
    var more = state.records.length > shown.length ? '<button type="button" class="integy-v520-load-more" data-integy-v520-load-more>Load ' + Math.min(pageLimit(), state.records.length - shown.length) + ' more products</button>' : '';
    container.hidden = false;
    container.setAttribute('data-integy-v520-search-mode', state.mode);
    var grid = append ? one('.integy-v520-search-grid', container) : null;
    if (grid) {
      var previousCount = grid.children.length;
      var previousButton = one('[data-integy-v520-load-more]', container);
      var moveFocus = previousButton && document.activeElement === previousButton;
      grid.insertAdjacentHTML('beforeend', shown.slice(previousCount).map(function (record, index) {
        return exactCardMarkup(record, previousCount + index);
      }).join(''));
      grid.setAttribute('data-result-count', String(shown.length));
      var headingNode = one('[data-integy-v725-result-count]', container);
      if (headingNode) headingNode.innerHTML = heading;
      if (previousButton) {
        if (state.records.length > shown.length) previousButton.textContent = 'Load ' + Math.min(pageLimit(), state.records.length - shown.length) + ' more products';
        else previousButton.remove();
      }
      if (moveFocus && grid.children[previousCount]) {
        var nextTitle = one('.productitem--title a', grid.children[previousCount]);
        if (nextTitle) nextTitle.focus({ preventScroll: true });
      }
    } else {
      container.innerHTML = collectionHtml + '<header class="integy-v520-search-results__header"><p class="integy-v725-result-count" data-integy-v725-result-count role="status" aria-live="polite" aria-atomic="true">' + heading + '</p></header>' +
        '<div class="integy-v426-search-grid integy-v520-search-grid" data-result-count="' + shown.length + '">' + shown.map(exactCardMarkup).join('') + '</div>' + more;
    }
    v529ObserveSearchCards(container);
    if (window.IntegyV460DynamicQuickShop && typeof window.IntegyV460DynamicQuickShop.scan === 'function') {
      try { window.IntegyV460DynamicQuickShop.scan(container); } catch (error) {}
    }
    updateSearchPageLabel(shown.length, state.query, state.mode, state.records.length);
  }

  function renderOwnedSearchPage(records, query, mode, collections) {
    finishSearchRequest();
    records = rankProducts(records || [], query);
    collections = rankCollections(collections || [], query).slice(0, 4);
    ownedPageState = { records: records, query: query, mode: mode, collections: collections, visible: Math.min(pageLimit(), records.length) };
    paintOwnedSearchPage();
    var outer = one('.search--section .productgrid--outer');
    if (outer) {
      outer.classList.remove('layout--has-sidebar');
      outer.classList.add('layout--no-sidebar', 'integy-v520-owned-search-outer');
    }
    hideNativeSearchResults();
    root.classList.remove('integy-v520-search-page-pending', 'integy-v510-search-page-pending', 'integy-v509-exact-numeric-pending', 'integy-v431-fast-search-pending', 'integy-v432-fast-search-pending', 'integy-v520-search-runtime-failed');
    root.classList.add('integy-v520-search-page-owned');
    if (searchPageObserver) searchPageObserver.disconnect();
    var wrapper = one('.search--section .productgrid--wrapper');
    var container = exactResultsContainer();
    if (wrapper && container && window.MutationObserver) {
      searchPageObserver = new MutationObserver(function () {
        hideNativeSearchResults();
        if (!container.isConnected) {
          var masthead = one('.productgrid--masthead', wrapper);
          wrapper.insertBefore(container, masthead ? masthead.nextSibling : wrapper.firstChild);
        }
      });
      searchPageObserver.observe(wrapper, { childList: true, subtree: true });
    }
  }

  function renderSearchPageFailure(query, strict, message) {
    finishSearchRequest();
    var container = exactResultsContainer();
    if (!container) return;
    ownedPageState = null;
    if (!strict) {
      container.hidden = true;
      container.innerHTML = '';
      showNativeSearchResults();
      root.classList.remove('integy-v520-search-page-pending', 'integy-v510-search-page-pending', 'integy-v431-fast-search-pending', 'integy-v432-fast-search-pending', 'integy-v520-search-page-owned');
      root.classList.add('integy-v520-search-runtime-failed');
      return;
    }
    container.hidden = false;
    container.innerHTML = '<div class="integy-v520-page-error" role="status"><h1>' + (strict ? 'Exact SKU search unavailable' : 'Search could not load') + '</h1><p>' + escapeHtml(message || 'Please check your connection and try again.') + '</p><button type="button" data-integy-v520-page-retry>Retry search</button></div>';
    if (strict) hideNativeSearchResults(); else showNativeSearchResults();
    root.classList.remove('integy-v520-search-page-pending', 'integy-v510-search-page-pending', 'integy-v431-fast-search-pending', 'integy-v432-fast-search-pending');
    root.classList.toggle('integy-v520-search-page-owned', strict);
  }

  function releaseSearchPage() {
    finishSearchRequest();
    pageRequestSerial += 1;
    ownedPageState = null;
    root.classList.remove('integy-v520-search-page-pending', 'integy-v520-search-page-owned', 'integy-v510-search-page-pending', 'integy-v509-exact-numeric-pending');
    if (searchPageObserver) searchPageObserver.disconnect();
    var container = document.getElementById(resultsId);
    if (container) { container.hidden = true; container.innerHTML = ''; }
    showNativeSearchResults();
  }

  function runOwnedSearchPage(options) {
    options = options || {};
    if (!/\/search\/?$/.test(location.pathname)) return;
    var query = clean(new URLSearchParams(location.search).get('q'));
    /* V742: the server-rendered, Online Store published category expansion
       owns the 'truer' results. Do not overwrite its six cards with the
       search index's narrow one-result view. Other terms remain V741-owned. */
    var v742NativeGrid = one('[data-integy-v742-count]');
    if (query.toLowerCase() === 'truer' && v742NativeGrid) {
      var v742NativeCount = Number(v742NativeGrid.getAttribute('data-integy-v742-count')) || 0;
      if (v742NativeCount > 0) {
        releaseSearchPage();
        updateSearchPageLabel(v742NativeCount, query, 'broad', v742NativeCount);
        return;
      }
    }
    var pageKey = location.pathname + '?' + location.search.replace(/^\?/, '');
    if (pageKey === lastOwnedPageKey && searchPageInFlight && !options.retry) return;
    if (!options.force && pageKey === lastOwnedPageKey && (ownedPageState || searchPageFinished)) return;
    if (!query || query.length < 2) {
      lastOwnedPageKey = pageKey;
      return releaseSearchPage();
    }
    lastOwnedPageKey = pageKey;
    var serial = ++pageRequestSerial;
    var numeric = numericQuery(query);
    var skuQuery = skuLikeQuery(query);
    var nativeRecords = nativeSearchRecords();
    searchPageInFlight = true;
    searchPageFinished = false;
    window.clearTimeout(searchPageDeadline);
    searchPageDeadline = window.setTimeout(function () {
      if (serial !== pageRequestSerial) return;
      pageRequestSerial += 1;
      renderSearchPageFailure(query, !!(numeric || skuQuery));
    }, 8000);
    root.classList.add('integy-v520-search-page-pending');
    hideNativeSearchResults();
    var container = exactResultsContainer();
    if (container) {
      container.hidden = false;
      container.innerHTML = '<div class="integy-v520-page-loading" role="status">Searching products for “' + escapeHtml(query) + '”…</div>';
    }
    if (numeric) {
      Promise.all([numeric.length >= 4 ? exactNumericSearch(numeric) : Promise.resolve([]), numericPrefixSearch(numeric)]).then(function (sets) {
        if (serial !== pageRequestSerial) return;
        var nativeExact = exactNativeNumericRecords(nativeRecords, numeric, false);
        var nativePrefix = exactNativeNumericRecords(nativeRecords, numeric, true);
        var exactRecords = dedupeProducts((sets[0] || []).concat(nativeExact));
        var prefixRecords = dedupeProducts((sets[1] || []).concat(nativePrefix));
        if (exactRecords.length) return renderOwnedSearchPage(exactRecords, query, 'exact', []);
        if (prefixRecords.length) return renderOwnedSearchPage(prefixRecords, query, 'prefix', []);
        renderOwnedSearchPage([], query, 'empty', []);
      }).catch(function () {
        if (serial === pageRequestSerial) renderSearchPageFailure(query, true);
      });
      return;
    }
    Promise.all([
      localSearch(query),
      fetchPredictive(query),
      skuQuery ? exactSkuSearch(query) : Promise.resolve([]),
      v618AuthoritativeMenuModelSearch(query)
    ]).then(function (sets) {
      if (serial !== pageRequestSerial) return;
      var predictive = sets[1] || { products: [], collections: [] };
      predictive.collections = v625MergeCollections(v625BrandCollections(query), predictive.collections || []);
      var exact = dedupeProducts((sets[2] || []).concat(skuQuery ? exactNativeSkuRecords(nativeRecords, query) : []));
      if (exact.length) return renderOwnedSearchPage(exact, query, 'exact', predictive.collections || []);

      var menuModelResult = sets[3];
      if (menuModelResult && menuModelResult.records && menuModelResult.records.length) {
        var menuCollections = (menuModelResult.collections || []).concat((predictive.collections || []).filter(function (record) {
          return !(menuModelResult.collections || []).some(function (menuRecord) {
            return canonicalCollectionUrl(menuRecord) === canonicalCollectionUrl(record);
          });
        }));
        return renderOwnedSearchPage(menuModelResult.records, query, 'model', menuCollections);
      }

      return v617AuthoritativeModelSearch(query, predictive.collections || []).then(function (modelResult) {
        if (serial !== pageRequestSerial) return;
        if (modelResult && modelResult.records && modelResult.records.length) {
          var modelCollections = [modelResult.collection].concat((predictive.collections || []).filter(function (record) {
            return canonicalCollectionUrl(record) !== canonicalCollectionUrl(modelResult.collection);
          }));
          return renderOwnedSearchPage(modelResult.records, query, 'model', modelCollections);
        }
        var registryCollections = menuModelResult && menuModelResult.collections || [];
        var allCollections = registryCollections.concat((predictive.collections || []).filter(function (record) {
          return !registryCollections.some(function (menuRecord) {
            return canonicalCollectionUrl(menuRecord) === canonicalCollectionUrl(record);
          });
        }));
        var records = rankProducts((sets[0] || []).concat(predictive.products || [], nativeRecords), query);
        if (records.length || allCollections.length) return renderOwnedSearchPage(records, query, 'broad', allCollections);
        renderOwnedSearchPage([], query, 'empty', []);
      });
    }).catch(function () {
      if (serial === pageRequestSerial) renderSearchPageFailure(query, !!skuQuery);
    });
  }

  function fixSearchInputs() {
    all('input[type="search"],input[name="q"]').filter(isSearchInput).forEach(function (input) {
      var placeholderValue = clean(input.getAttribute('placeholder'));
      if (!placeholderValue || /^search\.form\.placeholder$/i.test(placeholderValue)) input.setAttribute('placeholder', 'What are you looking for?');
      if (!clean(input.getAttribute('aria-label')) || input.getAttribute('aria-label') === 'search.form.placeholder') input.setAttribute('aria-label', 'Search products');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', panelId);
      if (!input.hasAttribute('aria-expanded')) input.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!isHeaderSearchInput(input)) return;
    event.stopImmediatePropagation();
    event.stopPropagation();
    scheduleQuickSearch(input);
  }, true);

  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (!isHeaderSearchInput(input)) return;
    event.stopImmediatePropagation();
    event.stopPropagation();
    if (clean(input.value).length >= 2) scheduleQuickSearch(input);
  }, true);

  document.addEventListener('submit', function (event) {
    normalizeSearchForm(event.target);
    closePanel();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var returnInput = activeInput;
      closePanel();
      if (returnInput && returnInput.isConnected) returnInput.focus();
      return;
    }
    if (event.key === 'ArrowDown' && isHeaderSearchInput(event.target)) {
      var panel = document.getElementById(panelId);
      var first = panel && !panel.hidden ? one('a[href]', panel) : null;
      if (first) {
        event.preventDefault();
        first.focus();
      }
    }
  }, true);

  document.addEventListener('click', function (event) {
    var retry = event.target.closest && event.target.closest('[data-integy-v520-search-retry]');
    if (retry && activeInput) { event.preventDefault(); runQuickSearch(activeInput); return; }
    var pageRetry = event.target.closest && event.target.closest('[data-integy-v520-page-retry]');
    if (pageRetry) { event.preventDefault(); runOwnedSearchPage({ force: true, retry: true }); return; }
    var more = event.target.closest && event.target.closest('[data-integy-v520-load-more]');
    if (more && ownedPageState) { event.preventDefault(); ownedPageState.visible = Math.min(ownedPageState.records.length, ownedPageState.visible + pageLimit()); paintOwnedSearchPage(true); return; }
    var panel = document.getElementById(panelId);
    if (!panel || panel.hidden) return;
    if (panel.contains(event.target) || isSearchInput(event.target)) return;
    closePanel();
  }, true);

  function reposition() {
    if (activeInput) positionPanel(activeInput);
  }

  window.addEventListener('resize', reposition, { passive: true });
  window.addEventListener('scroll', reposition, { passive: true, capture: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', reposition, { passive: true });
    window.visualViewport.addEventListener('scroll', reposition, { passive: true });
  }
  window.addEventListener('pageshow', function (event) {
    closePanel();
    fixSearchInputs();
    /* V617: boot already owns the initial submitted search. Re-run only when the
       browser restores this page from back-forward cache; ordinary pageshow was
       causing every search (for example TRX-4) to execute twice. */
    if (event && event.persisted) runOwnedSearchPage({ force: true });
  });
  document.addEventListener('shopify:section:load', function () { v618VehicleModelRegistryCache = null; fixSearchInputs(); });

  api.version = 'V725';
  api.searchTimeoutMs = 5600;
  api.exactNumericSearch = exactNumericSearch;
  api.numericPrefixSearch = numericPrefixSearch;
  api.exactSkuSearch = exactSkuSearch;
  api.renderExactCard = exactCardMarkup;
  api.runOwnedSearchPage = runOwnedSearchPage;
  api.runSearchPage = runOwnedSearchPage; // V543: retire legacy submitted-search renderer while retaining helper APIs.
  window.IntegyV520Search = api;
  window.IntegyV520SearchOwner = {
    version: 'V725',
    exactNumericSearch: exactNumericSearch,
    numericPrefixSearch: numericPrefixSearch,
    exactSkuSearch: exactSkuSearch,
    close: closePanel,
    getPanel: getPanel,
    mountForInput: function (input) {
      if (!input) return getPanel();
      activeInput = input;
      return mountPanel(input);
    },
    restorePanel: function () {
      var panel = getPanel();
      if (panel.parentNode !== document.body && document.body) document.body.appendChild(panel);
      panel.classList.remove('integy-v520-search-panel--takeover');
      return panel;
    },
    runSearchPage: runOwnedSearchPage,
    refreshInputs: fixSearchInputs,
    modelRegistry: v618VehicleModelRegistry,
    resolveModel: v618ResolveMenuModels,
    authoritativeModelSearch: v618AuthoritativeMenuModelSearch,
    versionNote: 'V725 source-owned product facts + accessible incremental search'
  };

  function boot() {
    root.classList.add('integy-v520-search-owner');
    root.classList.remove('integy-v520-search-runtime-failed');
    if (window.INTEGY_V520_SEARCH_FAILSAFE) window.clearTimeout(window.INTEGY_V520_SEARCH_FAILSAFE);
    getPanel();
    fixSearchInputs();
    all('form[action*="/search"],form[role="search"]').forEach(normalizeSearchForm);
    runOwnedSearchPage();
    try { document.dispatchEvent(new CustomEvent('integy:v520-search-ready')); } catch (error) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
